// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/connector.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { EditorMarker } from "../../editor/v1/editor";
import { Struct } from "../../../../google/protobuf/struct";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { AppManagedStateBindingRef } from "./app_managed";
import { Any } from "../../../../google/protobuf/any";
import { File } from "../../filestore/v1/filestore";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.app.v1.GetConnectorSyncLifecycleRequest
 */
export interface GetConnectorSyncLifecycleRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
}
/**
 * ConnectorCredential is used by a connector to authenticate with conductor one.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorCredential
 */
export interface ConnectorCredential {
    /**
     * The appId of the app the connector is attached to.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The connectorId of the connector the credential is associated with.
     *
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * The id of the ConnectorCredential.
     *
     * @generated from protobuf field: string id = 3
     */
    id: string;
    /**
     * The datetime, in RFC3339 format, of when the ConnectorCredential was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the ConnectorCredential was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the ConnectorCredential was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6
     */
    deletedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the ConnectorCredential was last used.
     *
     * @generated from protobuf field: google.protobuf.Timestamp last_used_at = 7
     */
    lastUsedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the ConnectorCredential will expire.
     *
     * @generated from protobuf field: google.protobuf.Timestamp expires_time = 8
     */
    expiresTime?: Timestamp;
    /**
     * The display name of the ConnectorCredential.
     *
     * @generated from protobuf field: string display_name = 9
     */
    displayName: string;
    /**
     * The client id of the ConnectorCredential.
     *
     * @generated from protobuf field: string client_id = 10
     */
    clientId: string;
    /**
     * The client secret of the ConnectorCredential. It's only returned on creation.
     *
     * @generated from protobuf field: string client_secret = 11
     */
    clientSecret: string;
}
/**
 * ConnectorServiceGetCredentialsRequest is a request for getting connector credentials. It uses URL values for input.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceGetCredentialsRequest
 */
export interface ConnectorServiceGetCredentialsRequest {
    /**
     * The appId of the app the connector is attached to.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The connectorId of the connector that we are getting the credentials for.
     *
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * The id of the ConnectorCredential.
     *
     * @generated from protobuf field: string id = 3
     */
    id: string;
}
/**
 * ConnectorServiceGetCredentialsResponse is the response returned by the get method.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceGetCredentialsResponse
 */
export interface ConnectorServiceGetCredentialsResponse {
    /**
     * The connector credential returned by a get credentials request.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorCredential credential = 1
     */
    credential?: ConnectorCredential;
}
/**
 * ConnectorServiceRotateCredentialResponse is the response returned by the rotate method.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceRotateCredentialResponse
 */
export interface ConnectorServiceRotateCredentialResponse {
    /**
     * The returned connector credential object.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorCredential credential = 1
     */
    credential?: ConnectorCredential;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceListCredentialsRequest
 */
export interface ConnectorServiceListCredentialsRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceListCredentialsResponse
 */
export interface ConnectorServiceListCredentialsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.ConnectorCredential list = 1
     */
    list: ConnectorCredential[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * ConnectorServiceRotateCredentialRequest is a request for rotating connector credentials. It uses URL values for input.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceRotateCredentialRequest
 */
export interface ConnectorServiceRotateCredentialRequest {
    /**
     * The appId of the app the connector is attached to.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The connectorId of the connector that we are rotating the credentials for.
     *
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
}
/**
 * ConnectorServiceRevokeCredentialRequest is a request for revoking connector credentials. It uses URL values for input.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceRevokeCredentialRequest
 */
export interface ConnectorServiceRevokeCredentialRequest {
    /**
     * The appId of the app the connector is attached to.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The connectorId of the connector that we are revoking the credentials for.
     *
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * The id of the ConnectorCredential.
     *
     * @generated from protobuf field: string id = 3
     */
    id: string;
}
/**
 * Empty response body. Status code indicates success.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceRevokeCredentialResponse
 */
export interface ConnectorServiceRevokeCredentialResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceUploadRequest
 */
export interface ConnectorServiceUploadRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceUploadResponse
 */
export interface ConnectorServiceUploadResponse {
    /**
     * @generated from protobuf field: string url = 1
     */
    url: string;
}
/**
 * Signal the connector to start syncing. This puts the sync on the queue. It does not guarantee immediate sync. Long syncs still take minutes to hours.
 *
 * @generated from protobuf message c1.api.app.v1.ForceSyncRequest
 */
export interface ForceSyncRequest {
    /**
     * The AppID of the app the connector is attached to.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The ConnectorID of the connector that we are forcing to sync.
     *
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ForceSyncResponse
 */
export interface ForceSyncResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.ResumeSyncRequest
 */
export interface ResumeSyncRequest {
    /**
     * The AppID of the app the connector is attached to.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The ConnectorID of the connector that we are resuming the sync for.
     *
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ResumeSyncResponse
 */
export interface ResumeSyncResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.ConfirmSyncValidRequest
 */
export interface ConfirmSyncValidRequest {
    /**
     * The AppID of the app the connector is attached to.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The ConnectorID of the connector that we are confirming the sync for.
     *
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * The completed lifecycle id of the most recent sync we want to validate
     *
     * @generated from protobuf field: string sync_lifecycle_id = 3
     */
    syncLifecycleId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConfirmSyncValidResponse
 */
export interface ConfirmSyncValidResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.PauseSyncRequest
 */
export interface PauseSyncRequest {
    /**
     * The AppID of the app the connector is attached to.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The ConnectorID of the connector that we are pausing the sync for.
     *
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.PauseSyncResponse
 */
export interface PauseSyncResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.C1AppConfig
 */
export interface C1AppConfig {
}
/**
 * @generated from protobuf message c1.api.app.v1.FileConfig
 */
export interface FileConfig {
    /**
     * @generated from protobuf field: c1.api.filestore.v1.File file = 1
     */
    file?: File;
    /**
     * Map of KNOWN_COLUMNS -> FILE_COLUMNS
     *
     * @generated from protobuf field: map<string, string> column_map = 2
     */
    columnMap: {
        [key: string]: string;
    };
    /**
     * List of all FILE_COLUMNS
     *
     * @generated from protobuf field: repeated string available_columns = 3
     */
    availableColumns: string[];
    /**
     * Map of SPREADSHEET_COLUMNS -> USER_PROFILE_ATTRIBUTES
     *
     * @generated from protobuf field: map<string, string> profile_attribute_map = 4
     */
    profileAttributeMap: {
        [key: string]: string;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.KeyValueItem
 */
export interface KeyValueItem {
    /**
     * @generated from protobuf field: string key = 1
     */
    key: string;
    /**
     * @generated from protobuf field: string value = 2
     */
    value: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.KeyValues
 */
export interface KeyValues {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.KeyValueItem items = 1
     */
    items: KeyValueItem[];
}
/**
 * @generated from protobuf message c1.api.app.v1.StringMap
 */
export interface StringMap {
    /**
     * @generated from protobuf field: map<string, string> items = 1
     */
    items: {
        [key: string]: string;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.EnvValue
 */
export interface EnvValue {
    /**
     * @generated from protobuf oneof: value
     */
    value: {
        oneofKind: "stringValue";
        /**
         * @generated from protobuf field: string string_value = 1
         */
        stringValue: string;
    } | {
        oneofKind: "keyValues";
        /**
         * @generated from protobuf field: c1.api.app.v1.KeyValues key_values = 2
         */
        keyValues: KeyValues;
    } | {
        oneofKind: "stringMap";
        /**
         * @generated from protobuf field: c1.api.app.v1.StringMap string_map = 3
         */
        stringMap: StringMap;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.EnvConfig
 */
export interface EnvConfig {
    /**
     * @generated from protobuf field: map<string, c1.api.app.v1.EnvValue> configuration = 12
     */
    configuration: {
        [key: string]: EnvValue;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.Option
 */
export interface Option {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string value = 3
     */
    value: string;
}
/**
 * The ConnectorExpandMask is used to expand related objects on a connector.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorExpandMask
 */
export interface ConnectorExpandMask {
    /**
     * Paths that you want expanded in the response. Possible values are "app_id" and "*".
     *
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * OAuth2AuthorizedAs tracks the user that OAuthed with the connector.
 *
 * @generated from protobuf message c1.api.app.v1.OAuth2AuthorizedAs
 */
export interface OAuth2AuthorizedAs {
    /**
     * authEmail is the email of the user that authorized the connector using OAuth.
     *
     * @generated from protobuf field: string auth_email = 1
     */
    authEmail: string;
    /**
     * authorizedAt is the timestamp of when the connector was authorized with OAuth.
     *
     * @generated from protobuf field: google.protobuf.Timestamp authorized_at = 2
     */
    authorizedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.SyncConfig
 */
export interface SyncConfig {
    /**
     * @generated from protobuf field: repeated string sync_resource_type_ids = 21
     */
    syncResourceTypeIds: string[];
}
/**
 * A Connector is used to sync objects into Apps
 *
 * @generated from protobuf message c1.api.app.v1.Connector
 */
export interface Connector {
    /**
     * The id of the app the connector is associated with.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The id of the connector.
     *
     * @generated from protobuf field: string id = 2
     */
    id: string;
    /**
     * The datetime, in RFC3339 format, of when the connector was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the connector was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the connector was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5
     */
    deletedAt?: Timestamp;
    /**
     * The display name of the connector.
     *
     * @generated from protobuf field: string display_name = 6
     */
    displayName: string;
    /**
     * The description of the connector.
     *
     * @generated from protobuf field: string description = 7
     */
    description: string;
    /**
     * Contains an arbitrary serialized message along with a @type that describes the type of the serialized message.
     * ONLY contains a FileConfig or EnvConfig
     *
     * @generated from protobuf field: google.protobuf.Any config = 8
     */
    config?: Any;
    /**
     * The downloadUrl for a spreadsheet if the connector was created from uploading a file.
     *
     * @generated from protobuf field: string download_url = 9
     */
    downloadUrl: string;
    /**
     * The catalogId describes which catalog entry this connector is an instance of. For example, every Okta connector will have the same catalogId indicating it is an Okta connector.
     *
     * @generated from protobuf field: string catalog_id = 10
     */
    catalogId: string;
    /**
     * If the connector requires authenticating with OAuth, this field is used to track the authenticated user.
     *
     * @generated from protobuf field: c1.api.app.v1.OAuth2AuthorizedAs oauth_authorized_as = 11
     */
    oauthAuthorizedAs?: OAuth2AuthorizedAs;
    /**
     * The status field on the connector is used to track the status of the connectors sync, and when syncing last started, completed, or caused the connector to update.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorStatus status = 12
     */
    status?: ConnectorStatus;
    /**
     * The userIds field is used to define the integration owners of the connector.
     *
     * @generated from protobuf field: repeated string user_ids = 13
     */
    userIds: string[];
    /**
     * The datetime, in RFC3339 format, of when sync for the connector was disabled.
     *
     * @generated from protobuf field: google.protobuf.Timestamp sync_disabled_at = 14
     */
    syncDisabledAt?: Timestamp;
    /**
     * The reason the connector sync was disabled.
     *
     * @generated from protobuf field: string sync_disabled_reason = 15
     */
    syncDisabledReason: string;
    /**
     * The category of the connector sync that was disabled.
     *
     * @generated from protobuf field: string sync_disabled_category = 16
     */
    syncDisabledCategory: string;
    /**
     * List of profile attributes to sync, when set only these attributes will be synced
     *
     * @generated from protobuf field: repeated string profile_allow_list = 17
     */
    profileAllowList: string[];
    /**
     * List of profile attributes to ignore (not sync), when set other attributes will be synced, but these will not.
     *
     * @generated from protobuf field: repeated string profile_ignore_list = 18
     */
    profileIgnoreList: string[];
    /**
     * @generated from protobuf field: bool disable_check_bad_sync = 19
     */
    disableCheckBadSync: boolean;
    /**
     * @generated from protobuf field: bool can_resume_sync = 20
     */
    canResumeSync: boolean;
    /**
     * @generated from protobuf field: c1.api.app.v1.SyncConfig sync_config = 21
     */
    syncConfig?: SyncConfig;
    /**
     * @generated from protobuf field: c1.api.app.v1.ConnectorSyncCronSchedule connector_sync_cron_schedule = 22
     */
    connectorSyncCronSchedule?: ConnectorSyncCronSchedule;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorRef
 */
export interface ConnectorRef {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
}
/**
 * The status field on the connector is used to track the status of the connectors sync, and when syncing last started, completed, or caused the connector to update.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorStatus
 */
export interface ConnectorStatus {
    /**
     * The status of the connector sync.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorStatus.SyncStatus status = 1
     */
    status: ConnectorStatus_SyncStatus;
    /**
     * The last error encountered by the connector.
     *
     * @generated from protobuf field: string last_error = 2
     */
    lastError: string;
    /**
     * A timestamp, in RFC3339 format, when the connector's most recently sync started at.
     *
     * @generated from protobuf field: google.protobuf.Timestamp started_at = 3
     */
    startedAt?: Timestamp;
    /**
     * A timestamp, in RFC3339 format, when the connector's most recently sync status updated at.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * A timestamp, in RFC3339 format, when the connector's most recently sync completed at.
     *
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 5
     */
    completedAt?: Timestamp;
}
/**
 * @generated from protobuf enum c1.api.app.v1.ConnectorStatus.SyncStatus
 */
export enum ConnectorStatus_SyncStatus {
    /**
     * Sync status unspecified. If returned in a get response this should be considered invalid.
     *
     * @generated from protobuf enum value: SYNC_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Sync is running.
     *
     * @generated from protobuf enum value: SYNC_STATUS_RUNNING = 1;
     */
    RUNNING = 1,
    /**
     * Sync is done.
     *
     * @generated from protobuf enum value: SYNC_STATUS_DONE = 2;
     */
    DONE = 2,
    /**
     * Sync encountered an error.
     *
     * @generated from protobuf enum value: SYNC_STATUS_ERROR = 3;
     */
    ERROR = 3,
    /**
     * Sync is disabled
     *
     * @generated from protobuf enum value: SYNC_STATUS_DISABLED = 4;
     */
    DISABLED = 4
}
/**
 * The ConnectorView object provides a connector response object, as well as JSONPATHs to related objects provided by expanders.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorView
 */
export interface ConnectorView {
    /**
     * The connector object being returned by the request.
     *
     * @generated from protobuf field: c1.api.app.v1.Connector connector = 1
     */
    connector?: Connector;
    /**
     * JSONPATH expression indicating the location of the App object in the expanded array.
     *
     * @generated from protobuf field: string app_path = 3
     */
    appPath: string;
    /**
     * JSONPATH expression indicating the location of the User object in the expanded array. This is the user that is a direct target of the ticket without a specific relationship to a potentially non-existent app user.
     *
     * @generated from protobuf field: string users_path = 4
     */
    usersPath: string;
    /**
     * JSONPATH expression indicating the location of the ConnectorCapabilities object in the expanded array.
     *
     * @generated from protobuf field: string capabilities_path = 5
     */
    capabilitiesPath: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceCreateRequest
 */
export interface ConnectorServiceCreateRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @generated from protobuf field: google.protobuf.Any config = 4
     */
    config?: Any;
    /**
     * @generated from protobuf field: string catalog_id = 5
     */
    catalogId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.ConnectorExpandMask expand_mask = 6
     */
    expandMask?: ConnectorExpandMask;
    /**
     * @generated from protobuf field: repeated string user_ids = 7
     */
    userIds: string[];
}
/**
 * The ConnectorServiceCreateDelegatedRequest message contains the fields required to create a connector.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceCreateDelegatedRequest
 */
export interface ConnectorServiceCreateDelegatedRequest {
    /**
     * The displayName of the connector.
     *
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * The description of the connector.
     *
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * The catalogId describes which catalog entry this connector is an instance of. For example, every Okta connector will have the same catalogId indicating it is an Okta connector.
     *
     * @generated from protobuf field: string catalog_id = 3
     */
    catalogId: string;
    /**
     * The appId of the app the connector is attached to.
     *
     * @generated from protobuf field: string app_id = 4
     */
    appId: string;
    /**
     * The userIds field is used to define the integration owners of the connector.
     *
     * @generated from protobuf field: repeated string user_ids = 5
     */
    userIds: string[];
    /**
     * The list of paths to expand in the return value expanded list.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorExpandMask expand_mask = 6
     */
    expandMask?: ConnectorExpandMask;
    /**
     * For promoting from an unmanaged app
     *
     * @generated from protobuf field: c1.api.app.v1.AppManagedStateBindingRef app_managed_state_binding_ref = 7
     */
    appManagedStateBindingRef?: AppManagedStateBindingRef;
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateAuthorizeURLRequest
 */
export interface CreateAuthorizeURLRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateAuthorizeURLResponse
 */
export interface CreateAuthorizeURLResponse {
    /**
     * @generated from protobuf field: string authorization_url = 1
     */
    authorizationUrl: string;
}
/**
 * The ConnectorServiceGetResponse message contains the connectorView, and an expand mask.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceGetResponse
 */
export interface ConnectorServiceGetResponse {
    /**
     * The connector view contains the connector and paths to objects referenced by the connector.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorView connector_view = 1
     */
    connectorView?: ConnectorView;
    /**
     * The array of expanded items indicated by the request.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * The ConnectorServiceCreateResponse is the response returned from creating a connector.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceCreateResponse
 */
export interface ConnectorServiceCreateResponse {
    /**
     * The connector view returned by a create request.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorView connector_view = 1
     */
    connectorView?: ConnectorView;
    /**
     * The array of expanded items indicated by the request.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * The ConnectorServiceUpdateRequest message contains the fields required to update a connector.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceUpdateRequest
 */
export interface ConnectorServiceUpdateRequest {
    /**
     * The connector object where the fields to update are set.
     *
     * @generated from protobuf field: c1.api.app.v1.Connector connector = 1
     */
    connector?: Connector;
    /**
     * A comma-separated list of fields to update. If empty, all fields will be updated.
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
    /**
     * The list of paths to expand in the return value expanded list.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorExpandMask expand_mask = 3
     */
    expandMask?: ConnectorExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceUpdateAllowIgnoreListRequest
 */
export interface ConnectorServiceUpdateAllowIgnoreListRequest {
    /**
     * The connector object where the fields to update are set.
     *
     * @generated from protobuf field: c1.api.app.v1.Connector connector = 1
     */
    connector?: Connector;
    /**
     * A comma-separated list of fields to update. If empty, all fields will be updated.
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
    /**
     * The list of paths to expand in the return value expanded list.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorExpandMask expand_mask = 3
     */
    expandMask?: ConnectorExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceUpdateSyncResourceTypesConfigRequest
 */
export interface ConnectorServiceUpdateSyncResourceTypesConfigRequest {
    /**
     * The connector object where the fields to update are set.
     *
     * @generated from protobuf field: c1.api.app.v1.Connector connector = 1
     */
    connector?: Connector;
    /**
     * A comma-separated list of fields to update. If empty, all fields will be updated.
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
    /**
     * The list of paths to expand in the return value expanded list.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorExpandMask expand_mask = 3
     */
    expandMask?: ConnectorExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceUpdateAdvancedConfigRequest
 */
export interface ConnectorServiceUpdateAdvancedConfigRequest {
    /**
     * The connector object where the fields to update are set.
     *
     * @generated from protobuf field: c1.api.app.v1.Connector connector = 1
     */
    connector?: Connector;
    /**
     * A comma-separated list of fields to update. If empty, all fields will be updated.
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
    /**
     * The list of paths to expand in the return value expanded list.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorExpandMask expand_mask = 3
     */
    expandMask?: ConnectorExpandMask;
}
/**
 * The ConnectorServiceUpdateDelegatedRequest message contains the fields required to update a connector.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceUpdateDelegatedRequest
 */
export interface ConnectorServiceUpdateDelegatedRequest {
    /**
     * The connector object where the fields to update are set.
     *
     * @generated from protobuf field: c1.api.app.v1.Connector connector = 1
     */
    connector?: Connector;
    /**
     * A comma-separated list of fields to update. If empty, all fields will be updated.
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
    /**
     * The list of paths to expand in the return value expanded list.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorExpandMask expand_mask = 3
     */
    expandMask?: ConnectorExpandMask;
}
/**
 * ConnectorServiceUpdateResponse is the response returned by the update method.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceUpdateResponse
 */
export interface ConnectorServiceUpdateResponse {
    /**
     * The connector view returned by an update.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorView connector_view = 1
     */
    connectorView?: ConnectorView;
    /**
     * The array of expanded items indicated by the request.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * ConnectorServiceGetRequest is the request message for the get method.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceGetRequest
 */
export interface ConnectorServiceGetRequest {
    /**
     * The appId of the app the connector is attached to.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The id of the connector.
     *
     * @generated from protobuf field: string id = 2
     */
    id: string;
    /**
     * The list of paths to expand in the return value expanded list.
     *
     * @generated from protobuf field: c1.api.app.v1.ConnectorExpandMask expand_mask = 3
     */
    expandMask?: ConnectorExpandMask;
}
/**
 * ConnectorServiceDeleteRequest is a request for deleting a connector. It uses URL values for input.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceDeleteRequest
 */
export interface ConnectorServiceDeleteRequest {
    /**
     * The appId of the app the connector is attached to.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The id of the connector.
     *
     * @generated from protobuf field: string id = 2
     */
    id: string;
}
/**
 * Empty response body. Status code indicates success.
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceDeleteResponse
 */
export interface ConnectorServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceListRequest
 */
export interface ConnectorServiceListRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.ConnectorExpandMask expand_mask = 4
     */
    expandMask?: ConnectorExpandMask;
}
/**
 * The ConnectorServiceListResponse message contains a list of results and a nextPageToken if applicable
 *
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceListResponse
 */
export interface ConnectorServiceListResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request
     *
     * @generated from protobuf field: repeated c1.api.app.v1.ConnectorView list = 1
     */
    list: ConnectorView[];
    /**
     * List of serialized related objects
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size. The server returns one page of results and the nextPageToken until all results are retreived. To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceLogsRequest
 */
export interface ConnectorServiceLogsRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorLog
 */
export interface ConnectorLog {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: string msg = 3
     */
    msg: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct fields = 4
     */
    fields?: Struct;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorServiceLogsResponse
 */
export interface ConnectorServiceLogsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.ConnectorLog list = 1
     */
    list: ConnectorLog[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorConfigFieldActivity
 */
export interface ConnectorConfigFieldActivity {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string field_name = 3
     */
    fieldName: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 7
     */
    expiresAt?: Timestamp;
    /**
     * @generated from protobuf field: string error = 8
     */
    error: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.Option options = 9
     */
    options: Option[];
    /**
     * @generated from protobuf field: c1.api.app.v1.FieldActivityState state = 10
     */
    state: FieldActivityState;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetConnectorConfigFieldActivityRequest
 */
export interface GetConnectorConfigFieldActivityRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string field_name = 3
     */
    fieldName: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetConnectorConfigFieldActivityResponse
 */
export interface GetConnectorConfigFieldActivityResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.ConnectorConfigFieldActivity item = 1
     */
    item?: ConnectorConfigFieldActivity;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorSyncLifecycle
 */
export interface ConnectorSyncLifecycle {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string id = 3
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.app.v1.ConnectorSyncLifecycleStatus status = 6
     */
    status: ConnectorSyncLifecycleStatus;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sync_started_at = 7
     */
    syncStartedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sync_completed_at = 8
     */
    syncCompletedAt?: Timestamp;
    /**
     * @generated from protobuf field: map<string, int64> stats = 9
     */
    stats: {
        [key: string]: number;
    };
    /**
     * @generated from protobuf field: string c1z_sync_id = 10
     */
    c1ZSyncId: string;
    /**
     * @generated from protobuf field: string sync_type = 11
     */
    syncType: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp processing_started_at = 12
     */
    processingStartedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp processing_completed_at = 13
     */
    processingCompletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorSyncLifecycleRef
 */
export interface ConnectorSyncLifecycleRef {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetConnectorAccountCreationSchemaRequest
 */
export interface GetConnectorAccountCreationSchemaRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetConnectorAccountCreationSchemaResponse
 */
export interface GetConnectorAccountCreationSchemaResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.ConnectorAccountCreationSchema account_creation_schema = 1
     */
    accountCreationSchema?: ConnectorAccountCreationSchema;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorAccountCreationSchema
 */
export interface ConnectorAccountCreationSchema {
    /**
     * @generated from protobuf field: string tenant_id = 1
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 3
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string id = 4
     */
    id: string;
    /**
     * @generated from protobuf field: map<string, c1.api.app.v1.ConnectorAccountCreationSchema.Field> field_map = 5
     */
    fieldMap: {
        [key: string]: ConnectorAccountCreationSchema_Field;
    };
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 8
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.Field
 */
export interface ConnectorAccountCreationSchema_Field {
    /**
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * @generated from protobuf field: bool required = 2
     */
    required: boolean;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @generated from protobuf field: string placeholder = 4
     */
    placeholder: string;
    /**
     * @generated from protobuf field: int32 order = 5
     */
    order: number;
    /**
     * @generated from protobuf field: bool deprecated = 6
     */
    deprecated: boolean;
    /**
     * @generated from protobuf oneof: field
     */
    field: {
        oneofKind: "str";
        /**
         * @generated from protobuf field: c1.api.app.v1.ConnectorAccountCreationSchema.StringField str = 100
         */
        str: ConnectorAccountCreationSchema_StringField;
    } | {
        oneofKind: "bool";
        /**
         * @generated from protobuf field: c1.api.app.v1.ConnectorAccountCreationSchema.BoolField bool = 101
         */
        bool: ConnectorAccountCreationSchema_BoolField;
    } | {
        oneofKind: "strList";
        /**
         * @generated from protobuf field: c1.api.app.v1.ConnectorAccountCreationSchema.StringListField str_list = 102
         */
        strList: ConnectorAccountCreationSchema_StringListField;
    } | {
        oneofKind: "i";
        /**
         * @generated from protobuf field: c1.api.app.v1.ConnectorAccountCreationSchema.IntField i = 103
         */
        i: ConnectorAccountCreationSchema_IntField;
    } | {
        oneofKind: "m";
        /**
         * @generated from protobuf field: c1.api.app.v1.ConnectorAccountCreationSchema.MapField m = 104
         */
        m: ConnectorAccountCreationSchema_MapField;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.StringField
 */
export interface ConnectorAccountCreationSchema_StringField {
    /**
     * @generated from protobuf field: optional string default_value = 1
     */
    defaultValue?: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.BoolField
 */
export interface ConnectorAccountCreationSchema_BoolField {
    /**
     * @generated from protobuf field: optional bool default_value = 1
     */
    defaultValue?: boolean;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.StringListField
 */
export interface ConnectorAccountCreationSchema_StringListField {
    /**
     * @generated from protobuf field: repeated string default_value = 1
     */
    defaultValue: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.IntField
 */
export interface ConnectorAccountCreationSchema_IntField {
    /**
     * @generated from protobuf field: optional int32 default_value = 1
     */
    defaultValue?: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.MapField
 */
export interface ConnectorAccountCreationSchema_MapField {
    /**
     * @generated from protobuf field: map<string, c1.api.app.v1.ConnectorAccountCreationSchema.Field> default_value = 1
     */
    defaultValue: {
        [key: string]: ConnectorAccountCreationSchema_Field;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorExternalSourceConfigSetRequest
 */
export interface ConnectorExternalSourceConfigSetRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string external_app_id = 3
     */
    externalAppId: string;
    /**
     * @generated from protobuf field: string external_connector_id = 4
     */
    externalConnectorId: string;
    /**
     * @generated from protobuf field: string external_app_entitlement_filter_id = 5
     */
    externalAppEntitlementFilterId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorExternalSourceConfig
 */
export interface ConnectorExternalSourceConfig {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string external_app_id = 3
     */
    externalAppId: string;
    /**
     * @generated from protobuf field: string external_connector_id = 4
     */
    externalConnectorId: string;
    /**
     * @generated from protobuf field: string external_app_entitlement_filter_id = 5
     */
    externalAppEntitlementFilterId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 8
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorExternalSourceConfigGetRequest
 */
export interface ConnectorExternalSourceConfigGetRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListCompletedConnectorSyncLifecycleRequest
 */
export interface ListCompletedConnectorSyncLifecycleRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListCompletedConnectorSyncLifecycleResponse
 */
export interface ListCompletedConnectorSyncLifecycleResponse {
    /**
     * The list of connector sync lifecycles
     *
     * @generated from protobuf field: repeated c1.api.app.v1.ConnectorSyncLifecycle list = 1
     */
    list: ConnectorSyncLifecycle[];
    /**
     * Token to retrieve the next page of results, or empty if there are no more results.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetConnectorSyncDownloadURLRequest
 */
export interface GetConnectorSyncDownloadURLRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string sync_id = 3
     */
    syncId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetConnectorSyncDownloadURLResponse
 */
export interface GetConnectorSyncDownloadURLResponse {
    /**
     * Short-lived download URL for the connector sync artifact
     *
     * @generated from protobuf field: string download_url = 1
     */
    downloadUrl: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListConnectorSyncLifecycleRequest
 */
export interface ListConnectorSyncLifecycleRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListConnectorSyncLifecycleResponse
 */
export interface ListConnectorSyncLifecycleResponse {
    /**
     * The list of connector sync lifecycles
     *
     * @generated from protobuf field: repeated c1.api.app.v1.ConnectorSyncLifecycle list = 1
     */
    list: ConnectorSyncLifecycle[];
    /**
     * Token to retrieve the next page of results, or empty if there are no more results.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.EditorValidateRequest
 */
export interface EditorValidateRequest {
    /**
     * @generated from protobuf field: string text = 1
     */
    text: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.EditorValidateResponse
 */
export interface EditorValidateResponse {
    /**
     * @generated from protobuf field: repeated c1.api.editor.v1.EditorMarker markers = 1
     */
    markers: EditorMarker[];
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorScheduleCron
 */
export interface ConnectorScheduleCron {
    /**
     * @generated from protobuf field: string cron_spec = 1
     */
    cronSpec: string;
    /**
     * @generated from protobuf field: string timezone = 2
     */
    timezone: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.UpdateConnectorScheduleRequest
 */
export interface UpdateConnectorScheduleRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf oneof: schedule
     */
    schedule: {
        oneofKind: "cron";
        /**
         * @generated from protobuf field: c1.api.app.v1.ConnectorScheduleCron cron = 100
         */
        cron: ConnectorScheduleCron;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.UpdateConnectorScheduleResponse
 */
export interface UpdateConnectorScheduleResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.ConnectorSyncCronSchedule
 */
export interface ConnectorSyncCronSchedule {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start = 1
     */
    start?: Timestamp;
    /**
     * @generated from protobuf field: string cron_spec = 2
     */
    cronSpec: string;
    /**
     * @generated from protobuf field: string timezone = 3
     */
    timezone: string;
}
/**
 * @generated from protobuf enum c1.api.app.v1.FieldActivityState
 */
export enum FieldActivityState {
    /**
     * @generated from protobuf enum value: FIELD_ACTIVITY_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: FIELD_ACTIVITY_STATE_CREATED = 1;
     */
    CREATED = 1,
    /**
     * @generated from protobuf enum value: FIELD_ACTIVITY_STATE_PENDING = 2;
     */
    PENDING = 2,
    /**
     * @generated from protobuf enum value: FIELD_ACTIVITY_STATE_DONE = 3;
     */
    DONE = 3,
    /**
     * @generated from protobuf enum value: FIELD_ACTIVITY_STATE_ERROR = 4;
     */
    ERROR = 4
}
/**
 * @generated from protobuf enum c1.api.app.v1.ConnectorSyncLifecycleStatus
 */
export enum ConnectorSyncLifecycleStatus {
    /**
     * @generated from protobuf enum value: SYNC_LIFECYCLE_STATUS_UNSPECIFIED = 0;
     */
    SYNC_LIFECYCLE_STATUS_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: SYNC_LIFECYCLE_STATUS_SYNCING = 1;
     */
    SYNC_LIFECYCLE_STATUS_SYNCING = 1,
    /**
     * @generated from protobuf enum value: SYNC_LIFECYCLE_STATUS_ERRORED = 2;
     */
    SYNC_LIFECYCLE_STATUS_ERRORED = 2,
    /**
     * @generated from protobuf enum value: SYNC_LIFECYCLE_STATUS_COMPLETED = 3;
     */
    SYNC_LIFECYCLE_STATUS_COMPLETED = 3,
    /**
     * @generated from protobuf enum value: SYNC_LIFECYCLE_STATUS_NOT_CONNECTED = 4;
     */
    SYNC_LIFECYCLE_STATUS_NOT_CONNECTED = 4,
    /**
     * @generated from protobuf enum value: SYNC_LIFECYCLE_STATUS_SKIPPED = 5;
     */
    SYNC_LIFECYCLE_STATUS_SKIPPED = 5,
    /**
     * @generated from protobuf enum value: SYNC_LIFECYCLE_STATUS_ERRORED_NO_DATA = 6;
     */
    SYNC_LIFECYCLE_STATUS_ERRORED_NO_DATA = 6
}
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorSyncLifecycleRequest$Type extends MessageType<GetConnectorSyncLifecycleRequest> {
    constructor() {
        super("c1.api.app.v1.GetConnectorSyncLifecycleRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetConnectorSyncLifecycleRequest>): GetConnectorSyncLifecycleRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        if (value !== undefined)
            reflectionMergePartial<GetConnectorSyncLifecycleRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetConnectorSyncLifecycleRequest): GetConnectorSyncLifecycleRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetConnectorSyncLifecycleRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetConnectorSyncLifecycleRequest
 */
export const GetConnectorSyncLifecycleRequest = new GetConnectorSyncLifecycleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCredential$Type extends MessageType<ConnectorCredential> {
    constructor() {
        super("c1.api.app.v1.ConnectorCredential", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "last_used_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "expires_time", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 9, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } },
            { no: 10, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "ConnectorCredential" } }] } });
    }
    create(value?: PartialMessage<ConnectorCredential>): ConnectorCredential {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.id = "";
        message.displayName = "";
        message.clientId = "";
        message.clientSecret = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorCredential>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorCredential): ConnectorCredential {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string id */ 3:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 6:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* google.protobuf.Timestamp last_used_at */ 7:
                    message.lastUsedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastUsedAt);
                    break;
                case /* google.protobuf.Timestamp expires_time */ 8:
                    message.expiresTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresTime);
                    break;
                case /* string display_name */ 9:
                    message.displayName = reader.string();
                    break;
                case /* string client_id */ 10:
                    message.clientId = reader.string();
                    break;
                case /* string client_secret */ 11:
                    message.clientSecret = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorCredential, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string id = 3; */
        if (message.id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 6; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp last_used_at = 7; */
        if (message.lastUsedAt)
            Timestamp.internalBinaryWrite(message.lastUsedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp expires_time = 8; */
        if (message.expiresTime)
            Timestamp.internalBinaryWrite(message.expiresTime, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string display_name = 9; */
        if (message.displayName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.displayName);
        /* string client_id = 10; */
        if (message.clientId !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.clientId);
        /* string client_secret = 11; */
        if (message.clientSecret !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.clientSecret);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorCredential
 */
export const ConnectorCredential = new ConnectorCredential$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceGetCredentialsRequest$Type extends MessageType<ConnectorServiceGetCredentialsRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceGetCredentialsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "8", maxLen: "64" } } } }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceGetCredentialsRequest>): ConnectorServiceGetCredentialsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceGetCredentialsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceGetCredentialsRequest): ConnectorServiceGetCredentialsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string id */ 3:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceGetCredentialsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string id = 3; */
        if (message.id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceGetCredentialsRequest
 */
export const ConnectorServiceGetCredentialsRequest = new ConnectorServiceGetCredentialsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceGetCredentialsResponse$Type extends MessageType<ConnectorServiceGetCredentialsResponse> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceGetCredentialsResponse", [
            { no: 1, name: "credential", kind: "message", T: () => ConnectorCredential }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceGetCredentialsResponse>): ConnectorServiceGetCredentialsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceGetCredentialsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceGetCredentialsResponse): ConnectorServiceGetCredentialsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.ConnectorCredential credential */ 1:
                    message.credential = ConnectorCredential.internalBinaryRead(reader, reader.uint32(), options, message.credential);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceGetCredentialsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.ConnectorCredential credential = 1; */
        if (message.credential)
            ConnectorCredential.internalBinaryWrite(message.credential, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceGetCredentialsResponse
 */
export const ConnectorServiceGetCredentialsResponse = new ConnectorServiceGetCredentialsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceRotateCredentialResponse$Type extends MessageType<ConnectorServiceRotateCredentialResponse> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceRotateCredentialResponse", [
            { no: 1, name: "credential", kind: "message", T: () => ConnectorCredential }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceRotateCredentialResponse>): ConnectorServiceRotateCredentialResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceRotateCredentialResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceRotateCredentialResponse): ConnectorServiceRotateCredentialResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.ConnectorCredential credential */ 1:
                    message.credential = ConnectorCredential.internalBinaryRead(reader, reader.uint32(), options, message.credential);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceRotateCredentialResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.ConnectorCredential credential = 1; */
        if (message.credential)
            ConnectorCredential.internalBinaryWrite(message.credential, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceRotateCredentialResponse
 */
export const ConnectorServiceRotateCredentialResponse = new ConnectorServiceRotateCredentialResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceListCredentialsRequest$Type extends MessageType<ConnectorServiceListCredentialsRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceListCredentialsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceListCredentialsRequest>): ConnectorServiceListCredentialsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceListCredentialsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceListCredentialsRequest): ConnectorServiceListCredentialsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceListCredentialsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceListCredentialsRequest
 */
export const ConnectorServiceListCredentialsRequest = new ConnectorServiceListCredentialsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceListCredentialsResponse$Type extends MessageType<ConnectorServiceListCredentialsResponse> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceListCredentialsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorCredential },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceListCredentialsResponse>): ConnectorServiceListCredentialsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceListCredentialsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceListCredentialsResponse): ConnectorServiceListCredentialsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.ConnectorCredential list */ 1:
                    message.list.push(ConnectorCredential.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceListCredentialsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.ConnectorCredential list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ConnectorCredential.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceListCredentialsResponse
 */
export const ConnectorServiceListCredentialsResponse = new ConnectorServiceListCredentialsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceRotateCredentialRequest$Type extends MessageType<ConnectorServiceRotateCredentialRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceRotateCredentialRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "ConnectorCredential" } }] } });
    }
    create(value?: PartialMessage<ConnectorServiceRotateCredentialRequest>): ConnectorServiceRotateCredentialRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceRotateCredentialRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceRotateCredentialRequest): ConnectorServiceRotateCredentialRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceRotateCredentialRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceRotateCredentialRequest
 */
export const ConnectorServiceRotateCredentialRequest = new ConnectorServiceRotateCredentialRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceRevokeCredentialRequest$Type extends MessageType<ConnectorServiceRevokeCredentialRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceRevokeCredentialRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "8", maxLen: "64" } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "ConnectorCredential" } }] } });
    }
    create(value?: PartialMessage<ConnectorServiceRevokeCredentialRequest>): ConnectorServiceRevokeCredentialRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceRevokeCredentialRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceRevokeCredentialRequest): ConnectorServiceRevokeCredentialRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string id */ 3:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceRevokeCredentialRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string id = 3; */
        if (message.id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceRevokeCredentialRequest
 */
export const ConnectorServiceRevokeCredentialRequest = new ConnectorServiceRevokeCredentialRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceRevokeCredentialResponse$Type extends MessageType<ConnectorServiceRevokeCredentialResponse> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceRevokeCredentialResponse", [], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "ConnectorCredential" } }] } });
    }
    create(value?: PartialMessage<ConnectorServiceRevokeCredentialResponse>): ConnectorServiceRevokeCredentialResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceRevokeCredentialResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceRevokeCredentialResponse): ConnectorServiceRevokeCredentialResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceRevokeCredentialResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceRevokeCredentialResponse
 */
export const ConnectorServiceRevokeCredentialResponse = new ConnectorServiceRevokeCredentialResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceUploadRequest$Type extends MessageType<ConnectorServiceUploadRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceUploadRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceUploadRequest>): ConnectorServiceUploadRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceUploadRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceUploadRequest): ConnectorServiceUploadRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceUploadRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceUploadRequest
 */
export const ConnectorServiceUploadRequest = new ConnectorServiceUploadRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceUploadResponse$Type extends MessageType<ConnectorServiceUploadResponse> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceUploadResponse", [
            { no: 1, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceUploadResponse>): ConnectorServiceUploadResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.url = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceUploadResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceUploadResponse): ConnectorServiceUploadResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string url */ 1:
                    message.url = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceUploadResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string url = 1; */
        if (message.url !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.url);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceUploadResponse
 */
export const ConnectorServiceUploadResponse = new ConnectorServiceUploadResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ForceSyncRequest$Type extends MessageType<ForceSyncRequest> {
    constructor() {
        super("c1.api.app.v1.ForceSyncRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ForceSyncRequest>): ForceSyncRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        if (value !== undefined)
            reflectionMergePartial<ForceSyncRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ForceSyncRequest): ForceSyncRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ForceSyncRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ForceSyncRequest
 */
export const ForceSyncRequest = new ForceSyncRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ForceSyncResponse$Type extends MessageType<ForceSyncResponse> {
    constructor() {
        super("c1.api.app.v1.ForceSyncResponse", []);
    }
    create(value?: PartialMessage<ForceSyncResponse>): ForceSyncResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ForceSyncResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ForceSyncResponse): ForceSyncResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ForceSyncResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ForceSyncResponse
 */
export const ForceSyncResponse = new ForceSyncResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResumeSyncRequest$Type extends MessageType<ResumeSyncRequest> {
    constructor() {
        super("c1.api.app.v1.ResumeSyncRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ResumeSyncRequest>): ResumeSyncRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        if (value !== undefined)
            reflectionMergePartial<ResumeSyncRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResumeSyncRequest): ResumeSyncRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResumeSyncRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ResumeSyncRequest
 */
export const ResumeSyncRequest = new ResumeSyncRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResumeSyncResponse$Type extends MessageType<ResumeSyncResponse> {
    constructor() {
        super("c1.api.app.v1.ResumeSyncResponse", []);
    }
    create(value?: PartialMessage<ResumeSyncResponse>): ResumeSyncResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ResumeSyncResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResumeSyncResponse): ResumeSyncResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResumeSyncResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ResumeSyncResponse
 */
export const ResumeSyncResponse = new ResumeSyncResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfirmSyncValidRequest$Type extends MessageType<ConfirmSyncValidRequest> {
    constructor() {
        super("c1.api.app.v1.ConfirmSyncValidRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "sync_lifecycle_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ConfirmSyncValidRequest>): ConfirmSyncValidRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.syncLifecycleId = "";
        if (value !== undefined)
            reflectionMergePartial<ConfirmSyncValidRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConfirmSyncValidRequest): ConfirmSyncValidRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string sync_lifecycle_id */ 3:
                    message.syncLifecycleId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConfirmSyncValidRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string sync_lifecycle_id = 3; */
        if (message.syncLifecycleId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.syncLifecycleId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConfirmSyncValidRequest
 */
export const ConfirmSyncValidRequest = new ConfirmSyncValidRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfirmSyncValidResponse$Type extends MessageType<ConfirmSyncValidResponse> {
    constructor() {
        super("c1.api.app.v1.ConfirmSyncValidResponse", []);
    }
    create(value?: PartialMessage<ConfirmSyncValidResponse>): ConfirmSyncValidResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConfirmSyncValidResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConfirmSyncValidResponse): ConfirmSyncValidResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConfirmSyncValidResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConfirmSyncValidResponse
 */
export const ConfirmSyncValidResponse = new ConfirmSyncValidResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PauseSyncRequest$Type extends MessageType<PauseSyncRequest> {
    constructor() {
        super("c1.api.app.v1.PauseSyncRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<PauseSyncRequest>): PauseSyncRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        if (value !== undefined)
            reflectionMergePartial<PauseSyncRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PauseSyncRequest): PauseSyncRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PauseSyncRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.PauseSyncRequest
 */
export const PauseSyncRequest = new PauseSyncRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PauseSyncResponse$Type extends MessageType<PauseSyncResponse> {
    constructor() {
        super("c1.api.app.v1.PauseSyncResponse", []);
    }
    create(value?: PartialMessage<PauseSyncResponse>): PauseSyncResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PauseSyncResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PauseSyncResponse): PauseSyncResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PauseSyncResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.PauseSyncResponse
 */
export const PauseSyncResponse = new PauseSyncResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class C1AppConfig$Type extends MessageType<C1AppConfig> {
    constructor() {
        super("c1.api.app.v1.C1AppConfig", []);
    }
    create(value?: PartialMessage<C1AppConfig>): C1AppConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<C1AppConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: C1AppConfig): C1AppConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: C1AppConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.C1AppConfig
 */
export const C1AppConfig = new C1AppConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FileConfig$Type extends MessageType<FileConfig> {
    constructor() {
        super("c1.api.app.v1.FileConfig", [
            { no: 1, name: "file", kind: "message", T: () => File },
            { no: 2, name: "column_map", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 3, name: "available_columns", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "profile_attribute_map", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
    create(value?: PartialMessage<FileConfig>): FileConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.columnMap = {};
        message.availableColumns = [];
        message.profileAttributeMap = {};
        if (value !== undefined)
            reflectionMergePartial<FileConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FileConfig): FileConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.filestore.v1.File file */ 1:
                    message.file = File.internalBinaryRead(reader, reader.uint32(), options, message.file);
                    break;
                case /* map<string, string> column_map */ 2:
                    this.binaryReadMap2(message.columnMap, reader, options);
                    break;
                case /* repeated string available_columns */ 3:
                    message.availableColumns.push(reader.string());
                    break;
                case /* map<string, string> profile_attribute_map */ 4:
                    this.binaryReadMap4(message.profileAttributeMap, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: FileConfig["columnMap"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof FileConfig["columnMap"] | undefined, val: FileConfig["columnMap"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.app.v1.FileConfig.column_map");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    private binaryReadMap4(map: FileConfig["profileAttributeMap"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof FileConfig["profileAttributeMap"] | undefined, val: FileConfig["profileAttributeMap"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.app.v1.FileConfig.profile_attribute_map");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: FileConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.filestore.v1.File file = 1; */
        if (message.file)
            File.internalBinaryWrite(message.file, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> column_map = 2; */
        for (let k of globalThis.Object.keys(message.columnMap))
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.columnMap[k]).join();
        /* repeated string available_columns = 3; */
        for (let i = 0; i < message.availableColumns.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.availableColumns[i]);
        /* map<string, string> profile_attribute_map = 4; */
        for (let k of globalThis.Object.keys(message.profileAttributeMap))
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.profileAttributeMap[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.FileConfig
 */
export const FileConfig = new FileConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class KeyValueItem$Type extends MessageType<KeyValueItem> {
    constructor() {
        super("c1.api.app.v1.KeyValueItem", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<KeyValueItem>): KeyValueItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.key = "";
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial<KeyValueItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: KeyValueItem): KeyValueItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string key */ 1:
                    message.key = reader.string();
                    break;
                case /* string value */ 2:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: KeyValueItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string key = 1; */
        if (message.key !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.key);
        /* string value = 2; */
        if (message.value !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.KeyValueItem
 */
export const KeyValueItem = new KeyValueItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class KeyValues$Type extends MessageType<KeyValues> {
    constructor() {
        super("c1.api.app.v1.KeyValues", [
            { no: 1, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => KeyValueItem }
        ]);
    }
    create(value?: PartialMessage<KeyValues>): KeyValues {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<KeyValues>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: KeyValues): KeyValues {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.KeyValueItem items */ 1:
                    message.items.push(KeyValueItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: KeyValues, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.KeyValueItem items = 1; */
        for (let i = 0; i < message.items.length; i++)
            KeyValueItem.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.KeyValues
 */
export const KeyValues = new KeyValues$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StringMap$Type extends MessageType<StringMap> {
    constructor() {
        super("c1.api.app.v1.StringMap", [
            { no: 1, name: "items", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
    create(value?: PartialMessage<StringMap>): StringMap {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = {};
        if (value !== undefined)
            reflectionMergePartial<StringMap>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StringMap): StringMap {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<string, string> items */ 1:
                    this.binaryReadMap1(message.items, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: StringMap["items"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof StringMap["items"] | undefined, val: StringMap["items"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.app.v1.StringMap.items");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: StringMap, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<string, string> items = 1; */
        for (let k of globalThis.Object.keys(message.items))
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.items[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.StringMap
 */
export const StringMap = new StringMap$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnvValue$Type extends MessageType<EnvValue> {
    constructor() {
        super("c1.api.app.v1.EnvValue", [
            { no: 1, name: "string_value", kind: "scalar", oneof: "value", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "key_values", kind: "message", oneof: "value", T: () => KeyValues },
            { no: 3, name: "string_map", kind: "message", oneof: "value", T: () => StringMap }
        ]);
    }
    create(value?: PartialMessage<EnvValue>): EnvValue {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.value = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<EnvValue>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EnvValue): EnvValue {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string string_value */ 1:
                    message.value = {
                        oneofKind: "stringValue",
                        stringValue: reader.string()
                    };
                    break;
                case /* c1.api.app.v1.KeyValues key_values */ 2:
                    message.value = {
                        oneofKind: "keyValues",
                        keyValues: KeyValues.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).keyValues)
                    };
                    break;
                case /* c1.api.app.v1.StringMap string_map */ 3:
                    message.value = {
                        oneofKind: "stringMap",
                        stringMap: StringMap.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).stringMap)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EnvValue, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string string_value = 1; */
        if (message.value.oneofKind === "stringValue")
            writer.tag(1, WireType.LengthDelimited).string(message.value.stringValue);
        /* c1.api.app.v1.KeyValues key_values = 2; */
        if (message.value.oneofKind === "keyValues")
            KeyValues.internalBinaryWrite(message.value.keyValues, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.StringMap string_map = 3; */
        if (message.value.oneofKind === "stringMap")
            StringMap.internalBinaryWrite(message.value.stringMap, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.EnvValue
 */
export const EnvValue = new EnvValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnvConfig$Type extends MessageType<EnvConfig> {
    constructor() {
        super("c1.api.app.v1.EnvConfig", [
            { no: 12, name: "configuration", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => EnvValue } }
        ]);
    }
    create(value?: PartialMessage<EnvConfig>): EnvConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.configuration = {};
        if (value !== undefined)
            reflectionMergePartial<EnvConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EnvConfig): EnvConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<string, c1.api.app.v1.EnvValue> configuration */ 12:
                    this.binaryReadMap12(message.configuration, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap12(map: EnvConfig["configuration"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof EnvConfig["configuration"] | undefined, val: EnvConfig["configuration"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = EnvValue.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.app.v1.EnvConfig.configuration");
            }
        }
        map[key ?? ""] = val ?? EnvValue.create();
    }
    internalBinaryWrite(message: EnvConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<string, c1.api.app.v1.EnvValue> configuration = 12; */
        for (let k of globalThis.Object.keys(message.configuration)) {
            writer.tag(12, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            EnvValue.internalBinaryWrite(message.configuration[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.EnvConfig
 */
export const EnvConfig = new EnvConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Option$Type extends MessageType<Option> {
    constructor() {
        super("c1.api.app.v1.Option", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Option>): Option {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.name = "";
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial<Option>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Option): Option {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string value */ 3:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Option, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string value = 3; */
        if (message.value !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.Option
 */
export const Option = new Option$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorExpandMask$Type extends MessageType<ConnectorExpandMask> {
    constructor() {
        super("c1.api.app.v1.ConnectorExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<ConnectorExpandMask>): ConnectorExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<ConnectorExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorExpandMask): ConnectorExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorExpandMask
 */
export const ConnectorExpandMask = new ConnectorExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OAuth2AuthorizedAs$Type extends MessageType<OAuth2AuthorizedAs> {
    constructor() {
        super("c1.api.app.v1.OAuth2AuthorizedAs", [
            { no: 1, name: "auth_email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "authorized_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<OAuth2AuthorizedAs>): OAuth2AuthorizedAs {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.authEmail = "";
        if (value !== undefined)
            reflectionMergePartial<OAuth2AuthorizedAs>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OAuth2AuthorizedAs): OAuth2AuthorizedAs {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string auth_email */ 1:
                    message.authEmail = reader.string();
                    break;
                case /* google.protobuf.Timestamp authorized_at */ 2:
                    message.authorizedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.authorizedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OAuth2AuthorizedAs, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string auth_email = 1; */
        if (message.authEmail !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.authEmail);
        /* google.protobuf.Timestamp authorized_at = 2; */
        if (message.authorizedAt)
            Timestamp.internalBinaryWrite(message.authorizedAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.OAuth2AuthorizedAs
 */
export const OAuth2AuthorizedAs = new OAuth2AuthorizedAs$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SyncConfig$Type extends MessageType<SyncConfig> {
    constructor() {
        super("c1.api.app.v1.SyncConfig", [
            { no: 21, name: "sync_resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SyncConfig>): SyncConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.syncResourceTypeIds = [];
        if (value !== undefined)
            reflectionMergePartial<SyncConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SyncConfig): SyncConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string sync_resource_type_ids */ 21:
                    message.syncResourceTypeIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SyncConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string sync_resource_type_ids = 21; */
        for (let i = 0; i < message.syncResourceTypeIds.length; i++)
            writer.tag(21, WireType.LengthDelimited).string(message.syncResourceTypeIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SyncConfig
 */
export const SyncConfig = new SyncConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Connector$Type extends MessageType<Connector> {
    constructor() {
        super("c1.api.app.v1.Connector", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "512" } } } },
            { no: 7, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "4096" } } } },
            { no: 8, name: "config", kind: "message", T: () => Any },
            { no: 9, name: "download_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 10, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "oauth_authorized_as", kind: "message", T: () => OAuth2AuthorizedAs, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 12, name: "status", kind: "message", T: () => ConnectorStatus, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 13, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "sync_disabled_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 15, name: "sync_disabled_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "sync_disabled_category", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "profile_allow_list", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "profile_ignore_list", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "disable_check_bad_sync", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "can_resume_sync", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "sync_config", kind: "message", T: () => SyncConfig },
            { no: 22, name: "connector_sync_cron_schedule", kind: "message", T: () => ConnectorSyncCronSchedule }
        ]);
    }
    create(value?: PartialMessage<Connector>): Connector {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.id = "";
        message.displayName = "";
        message.description = "";
        message.downloadUrl = "";
        message.catalogId = "";
        message.userIds = [];
        message.syncDisabledReason = "";
        message.syncDisabledCategory = "";
        message.profileAllowList = [];
        message.profileIgnoreList = [];
        message.disableCheckBadSync = false;
        message.canResumeSync = false;
        if (value !== undefined)
            reflectionMergePartial<Connector>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Connector): Connector {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 5:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* string display_name */ 6:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 7:
                    message.description = reader.string();
                    break;
                case /* google.protobuf.Any config */ 8:
                    message.config = Any.internalBinaryRead(reader, reader.uint32(), options, message.config);
                    break;
                case /* string download_url */ 9:
                    message.downloadUrl = reader.string();
                    break;
                case /* string catalog_id */ 10:
                    message.catalogId = reader.string();
                    break;
                case /* c1.api.app.v1.OAuth2AuthorizedAs oauth_authorized_as */ 11:
                    message.oauthAuthorizedAs = OAuth2AuthorizedAs.internalBinaryRead(reader, reader.uint32(), options, message.oauthAuthorizedAs);
                    break;
                case /* c1.api.app.v1.ConnectorStatus status */ 12:
                    message.status = ConnectorStatus.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* repeated string user_ids */ 13:
                    message.userIds.push(reader.string());
                    break;
                case /* google.protobuf.Timestamp sync_disabled_at */ 14:
                    message.syncDisabledAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.syncDisabledAt);
                    break;
                case /* string sync_disabled_reason */ 15:
                    message.syncDisabledReason = reader.string();
                    break;
                case /* string sync_disabled_category */ 16:
                    message.syncDisabledCategory = reader.string();
                    break;
                case /* repeated string profile_allow_list */ 17:
                    message.profileAllowList.push(reader.string());
                    break;
                case /* repeated string profile_ignore_list */ 18:
                    message.profileIgnoreList.push(reader.string());
                    break;
                case /* bool disable_check_bad_sync */ 19:
                    message.disableCheckBadSync = reader.bool();
                    break;
                case /* bool can_resume_sync */ 20:
                    message.canResumeSync = reader.bool();
                    break;
                case /* c1.api.app.v1.SyncConfig sync_config */ 21:
                    message.syncConfig = SyncConfig.internalBinaryRead(reader, reader.uint32(), options, message.syncConfig);
                    break;
                case /* c1.api.app.v1.ConnectorSyncCronSchedule connector_sync_cron_schedule */ 22:
                    message.connectorSyncCronSchedule = ConnectorSyncCronSchedule.internalBinaryRead(reader, reader.uint32(), options, message.connectorSyncCronSchedule);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Connector, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 5; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string display_name = 6; */
        if (message.displayName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.displayName);
        /* string description = 7; */
        if (message.description !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.description);
        /* google.protobuf.Any config = 8; */
        if (message.config)
            Any.internalBinaryWrite(message.config, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string download_url = 9; */
        if (message.downloadUrl !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.downloadUrl);
        /* string catalog_id = 10; */
        if (message.catalogId !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.catalogId);
        /* c1.api.app.v1.OAuth2AuthorizedAs oauth_authorized_as = 11; */
        if (message.oauthAuthorizedAs)
            OAuth2AuthorizedAs.internalBinaryWrite(message.oauthAuthorizedAs, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.ConnectorStatus status = 12; */
        if (message.status)
            ConnectorStatus.internalBinaryWrite(message.status, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated string user_ids = 13; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(13, WireType.LengthDelimited).string(message.userIds[i]);
        /* google.protobuf.Timestamp sync_disabled_at = 14; */
        if (message.syncDisabledAt)
            Timestamp.internalBinaryWrite(message.syncDisabledAt, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* string sync_disabled_reason = 15; */
        if (message.syncDisabledReason !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.syncDisabledReason);
        /* string sync_disabled_category = 16; */
        if (message.syncDisabledCategory !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.syncDisabledCategory);
        /* repeated string profile_allow_list = 17; */
        for (let i = 0; i < message.profileAllowList.length; i++)
            writer.tag(17, WireType.LengthDelimited).string(message.profileAllowList[i]);
        /* repeated string profile_ignore_list = 18; */
        for (let i = 0; i < message.profileIgnoreList.length; i++)
            writer.tag(18, WireType.LengthDelimited).string(message.profileIgnoreList[i]);
        /* bool disable_check_bad_sync = 19; */
        if (message.disableCheckBadSync !== false)
            writer.tag(19, WireType.Varint).bool(message.disableCheckBadSync);
        /* bool can_resume_sync = 20; */
        if (message.canResumeSync !== false)
            writer.tag(20, WireType.Varint).bool(message.canResumeSync);
        /* c1.api.app.v1.SyncConfig sync_config = 21; */
        if (message.syncConfig)
            SyncConfig.internalBinaryWrite(message.syncConfig, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.ConnectorSyncCronSchedule connector_sync_cron_schedule = 22; */
        if (message.connectorSyncCronSchedule)
            ConnectorSyncCronSchedule.internalBinaryWrite(message.connectorSyncCronSchedule, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.Connector
 */
export const Connector = new Connector$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorRef$Type extends MessageType<ConnectorRef> {
    constructor() {
        super("c1.api.app.v1.ConnectorRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorRef>): ConnectorRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorRef): ConnectorRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorRef
 */
export const ConnectorRef = new ConnectorRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorStatus$Type extends MessageType<ConnectorStatus> {
    constructor() {
        super("c1.api.app.v1.ConnectorStatus", [
            { no: 1, name: "status", kind: "enum", T: () => ["c1.api.app.v1.ConnectorStatus.SyncStatus", ConnectorStatus_SyncStatus, "SYNC_STATUS_"] },
            { no: 2, name: "last_error", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "started_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "completed_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<ConnectorStatus>): ConnectorStatus {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = 0;
        message.lastError = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorStatus): ConnectorStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.ConnectorStatus.SyncStatus status */ 1:
                    message.status = reader.int32();
                    break;
                case /* string last_error */ 2:
                    message.lastError = reader.string();
                    break;
                case /* google.protobuf.Timestamp started_at */ 3:
                    message.startedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startedAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp completed_at */ 5:
                    message.completedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.ConnectorStatus.SyncStatus status = 1; */
        if (message.status !== 0)
            writer.tag(1, WireType.Varint).int32(message.status);
        /* string last_error = 2; */
        if (message.lastError !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.lastError);
        /* google.protobuf.Timestamp started_at = 3; */
        if (message.startedAt)
            Timestamp.internalBinaryWrite(message.startedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp completed_at = 5; */
        if (message.completedAt)
            Timestamp.internalBinaryWrite(message.completedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorStatus
 */
export const ConnectorStatus = new ConnectorStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorView$Type extends MessageType<ConnectorView> {
    constructor() {
        super("c1.api.app.v1.ConnectorView", [
            { no: 1, name: "connector", kind: "message", T: () => Connector },
            { no: 3, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "users_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "capabilities_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorView>): ConnectorView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appPath = "";
        message.usersPath = "";
        message.capabilitiesPath = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorView): ConnectorView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.Connector connector */ 1:
                    message.connector = Connector.internalBinaryRead(reader, reader.uint32(), options, message.connector);
                    break;
                case /* string app_path */ 3:
                    message.appPath = reader.string();
                    break;
                case /* string users_path */ 4:
                    message.usersPath = reader.string();
                    break;
                case /* string capabilities_path */ 5:
                    message.capabilitiesPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.Connector connector = 1; */
        if (message.connector)
            Connector.internalBinaryWrite(message.connector, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_path = 3; */
        if (message.appPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appPath);
        /* string users_path = 4; */
        if (message.usersPath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.usersPath);
        /* string capabilities_path = 5; */
        if (message.capabilitiesPath !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.capabilitiesPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorView
 */
export const ConnectorView = new ConnectorView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceCreateRequest$Type extends MessageType<ConnectorServiceCreateRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceCreateRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "4096" } } } },
            { no: 4, name: "config", kind: "message", T: () => Any },
            { no: 5, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => ConnectorExpandMask },
            { no: 7, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceCreateRequest>): ConnectorServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.description = "";
        message.catalogId = "";
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceCreateRequest): ConnectorServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* google.protobuf.Any config */ 4:
                    message.config = Any.internalBinaryRead(reader, reader.uint32(), options, message.config);
                    break;
                case /* string catalog_id */ 5:
                    message.catalogId = reader.string();
                    break;
                case /* c1.api.app.v1.ConnectorExpandMask expand_mask */ 6:
                    message.expandMask = ConnectorExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated string user_ids */ 7:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* google.protobuf.Any config = 4; */
        if (message.config)
            Any.internalBinaryWrite(message.config, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string catalog_id = 5; */
        if (message.catalogId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.catalogId);
        /* c1.api.app.v1.ConnectorExpandMask expand_mask = 6; */
        if (message.expandMask)
            ConnectorExpandMask.internalBinaryWrite(message.expandMask, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated string user_ids = 7; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceCreateRequest
 */
export const ConnectorServiceCreateRequest = new ConnectorServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceCreateDelegatedRequest$Type extends MessageType<ConnectorServiceCreateDelegatedRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceCreateDelegatedRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 5, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => ConnectorExpandMask },
            { no: 7, name: "app_managed_state_binding_ref", kind: "message", T: () => AppManagedStateBindingRef }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceCreateDelegatedRequest>): ConnectorServiceCreateDelegatedRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.description = "";
        message.catalogId = "";
        message.appId = "";
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceCreateDelegatedRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceCreateDelegatedRequest): ConnectorServiceCreateDelegatedRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* string catalog_id */ 3:
                    message.catalogId = reader.string();
                    break;
                case /* string app_id */ 4:
                    message.appId = reader.string();
                    break;
                case /* repeated string user_ids */ 5:
                    message.userIds.push(reader.string());
                    break;
                case /* c1.api.app.v1.ConnectorExpandMask expand_mask */ 6:
                    message.expandMask = ConnectorExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* c1.api.app.v1.AppManagedStateBindingRef app_managed_state_binding_ref */ 7:
                    message.appManagedStateBindingRef = AppManagedStateBindingRef.internalBinaryRead(reader, reader.uint32(), options, message.appManagedStateBindingRef);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceCreateDelegatedRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* string catalog_id = 3; */
        if (message.catalogId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.catalogId);
        /* string app_id = 4; */
        if (message.appId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appId);
        /* repeated string user_ids = 5; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.userIds[i]);
        /* c1.api.app.v1.ConnectorExpandMask expand_mask = 6; */
        if (message.expandMask)
            ConnectorExpandMask.internalBinaryWrite(message.expandMask, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppManagedStateBindingRef app_managed_state_binding_ref = 7; */
        if (message.appManagedStateBindingRef)
            AppManagedStateBindingRef.internalBinaryWrite(message.appManagedStateBindingRef, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceCreateDelegatedRequest
 */
export const ConnectorServiceCreateDelegatedRequest = new ConnectorServiceCreateDelegatedRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAuthorizeURLRequest$Type extends MessageType<CreateAuthorizeURLRequest> {
    constructor() {
        super("c1.api.app.v1.CreateAuthorizeURLRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<CreateAuthorizeURLRequest>): CreateAuthorizeURLRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        if (value !== undefined)
            reflectionMergePartial<CreateAuthorizeURLRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAuthorizeURLRequest): CreateAuthorizeURLRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAuthorizeURLRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAuthorizeURLRequest
 */
export const CreateAuthorizeURLRequest = new CreateAuthorizeURLRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAuthorizeURLResponse$Type extends MessageType<CreateAuthorizeURLResponse> {
    constructor() {
        super("c1.api.app.v1.CreateAuthorizeURLResponse", [
            { no: 1, name: "authorization_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateAuthorizeURLResponse>): CreateAuthorizeURLResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.authorizationUrl = "";
        if (value !== undefined)
            reflectionMergePartial<CreateAuthorizeURLResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAuthorizeURLResponse): CreateAuthorizeURLResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string authorization_url */ 1:
                    message.authorizationUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAuthorizeURLResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string authorization_url = 1; */
        if (message.authorizationUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.authorizationUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAuthorizeURLResponse
 */
export const CreateAuthorizeURLResponse = new CreateAuthorizeURLResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceGetResponse$Type extends MessageType<ConnectorServiceGetResponse> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceGetResponse", [
            { no: 1, name: "connector_view", kind: "message", T: () => ConnectorView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceGetResponse>): ConnectorServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceGetResponse): ConnectorServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.ConnectorView connector_view */ 1:
                    message.connectorView = ConnectorView.internalBinaryRead(reader, reader.uint32(), options, message.connectorView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.ConnectorView connector_view = 1; */
        if (message.connectorView)
            ConnectorView.internalBinaryWrite(message.connectorView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceGetResponse
 */
export const ConnectorServiceGetResponse = new ConnectorServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceCreateResponse$Type extends MessageType<ConnectorServiceCreateResponse> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceCreateResponse", [
            { no: 1, name: "connector_view", kind: "message", T: () => ConnectorView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceCreateResponse>): ConnectorServiceCreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceCreateResponse): ConnectorServiceCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.ConnectorView connector_view */ 1:
                    message.connectorView = ConnectorView.internalBinaryRead(reader, reader.uint32(), options, message.connectorView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.ConnectorView connector_view = 1; */
        if (message.connectorView)
            ConnectorView.internalBinaryWrite(message.connectorView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceCreateResponse
 */
export const ConnectorServiceCreateResponse = new ConnectorServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceUpdateRequest$Type extends MessageType<ConnectorServiceUpdateRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceUpdateRequest", [
            { no: 1, name: "connector", kind: "message", T: () => Connector, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => ConnectorExpandMask }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceUpdateRequest>): ConnectorServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceUpdateRequest): ConnectorServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.Connector connector */ 1:
                    message.connector = Connector.internalBinaryRead(reader, reader.uint32(), options, message.connector);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                case /* c1.api.app.v1.ConnectorExpandMask expand_mask */ 3:
                    message.expandMask = ConnectorExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.Connector connector = 1; */
        if (message.connector)
            Connector.internalBinaryWrite(message.connector, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.ConnectorExpandMask expand_mask = 3; */
        if (message.expandMask)
            ConnectorExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceUpdateRequest
 */
export const ConnectorServiceUpdateRequest = new ConnectorServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceUpdateAllowIgnoreListRequest$Type extends MessageType<ConnectorServiceUpdateAllowIgnoreListRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceUpdateAllowIgnoreListRequest", [
            { no: 1, name: "connector", kind: "message", T: () => Connector, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => ConnectorExpandMask }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceUpdateAllowIgnoreListRequest>): ConnectorServiceUpdateAllowIgnoreListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceUpdateAllowIgnoreListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceUpdateAllowIgnoreListRequest): ConnectorServiceUpdateAllowIgnoreListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.Connector connector */ 1:
                    message.connector = Connector.internalBinaryRead(reader, reader.uint32(), options, message.connector);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                case /* c1.api.app.v1.ConnectorExpandMask expand_mask */ 3:
                    message.expandMask = ConnectorExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceUpdateAllowIgnoreListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.Connector connector = 1; */
        if (message.connector)
            Connector.internalBinaryWrite(message.connector, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.ConnectorExpandMask expand_mask = 3; */
        if (message.expandMask)
            ConnectorExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceUpdateAllowIgnoreListRequest
 */
export const ConnectorServiceUpdateAllowIgnoreListRequest = new ConnectorServiceUpdateAllowIgnoreListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceUpdateSyncResourceTypesConfigRequest$Type extends MessageType<ConnectorServiceUpdateSyncResourceTypesConfigRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceUpdateSyncResourceTypesConfigRequest", [
            { no: 1, name: "connector", kind: "message", T: () => Connector, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => ConnectorExpandMask }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceUpdateSyncResourceTypesConfigRequest>): ConnectorServiceUpdateSyncResourceTypesConfigRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceUpdateSyncResourceTypesConfigRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceUpdateSyncResourceTypesConfigRequest): ConnectorServiceUpdateSyncResourceTypesConfigRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.Connector connector */ 1:
                    message.connector = Connector.internalBinaryRead(reader, reader.uint32(), options, message.connector);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                case /* c1.api.app.v1.ConnectorExpandMask expand_mask */ 3:
                    message.expandMask = ConnectorExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceUpdateSyncResourceTypesConfigRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.Connector connector = 1; */
        if (message.connector)
            Connector.internalBinaryWrite(message.connector, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.ConnectorExpandMask expand_mask = 3; */
        if (message.expandMask)
            ConnectorExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceUpdateSyncResourceTypesConfigRequest
 */
export const ConnectorServiceUpdateSyncResourceTypesConfigRequest = new ConnectorServiceUpdateSyncResourceTypesConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceUpdateAdvancedConfigRequest$Type extends MessageType<ConnectorServiceUpdateAdvancedConfigRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceUpdateAdvancedConfigRequest", [
            { no: 1, name: "connector", kind: "message", T: () => Connector, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => ConnectorExpandMask }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceUpdateAdvancedConfigRequest>): ConnectorServiceUpdateAdvancedConfigRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceUpdateAdvancedConfigRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceUpdateAdvancedConfigRequest): ConnectorServiceUpdateAdvancedConfigRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.Connector connector */ 1:
                    message.connector = Connector.internalBinaryRead(reader, reader.uint32(), options, message.connector);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                case /* c1.api.app.v1.ConnectorExpandMask expand_mask */ 3:
                    message.expandMask = ConnectorExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceUpdateAdvancedConfigRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.Connector connector = 1; */
        if (message.connector)
            Connector.internalBinaryWrite(message.connector, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.ConnectorExpandMask expand_mask = 3; */
        if (message.expandMask)
            ConnectorExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceUpdateAdvancedConfigRequest
 */
export const ConnectorServiceUpdateAdvancedConfigRequest = new ConnectorServiceUpdateAdvancedConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceUpdateDelegatedRequest$Type extends MessageType<ConnectorServiceUpdateDelegatedRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceUpdateDelegatedRequest", [
            { no: 1, name: "connector", kind: "message", T: () => Connector, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => ConnectorExpandMask }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceUpdateDelegatedRequest>): ConnectorServiceUpdateDelegatedRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceUpdateDelegatedRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceUpdateDelegatedRequest): ConnectorServiceUpdateDelegatedRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.Connector connector */ 1:
                    message.connector = Connector.internalBinaryRead(reader, reader.uint32(), options, message.connector);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                case /* c1.api.app.v1.ConnectorExpandMask expand_mask */ 3:
                    message.expandMask = ConnectorExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceUpdateDelegatedRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.Connector connector = 1; */
        if (message.connector)
            Connector.internalBinaryWrite(message.connector, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.ConnectorExpandMask expand_mask = 3; */
        if (message.expandMask)
            ConnectorExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceUpdateDelegatedRequest
 */
export const ConnectorServiceUpdateDelegatedRequest = new ConnectorServiceUpdateDelegatedRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceUpdateResponse$Type extends MessageType<ConnectorServiceUpdateResponse> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceUpdateResponse", [
            { no: 1, name: "connector_view", kind: "message", T: () => ConnectorView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceUpdateResponse>): ConnectorServiceUpdateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceUpdateResponse): ConnectorServiceUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.ConnectorView connector_view */ 1:
                    message.connectorView = ConnectorView.internalBinaryRead(reader, reader.uint32(), options, message.connectorView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.ConnectorView connector_view = 1; */
        if (message.connectorView)
            ConnectorView.internalBinaryWrite(message.connectorView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceUpdateResponse
 */
export const ConnectorServiceUpdateResponse = new ConnectorServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceGetRequest$Type extends MessageType<ConnectorServiceGetRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceGetRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => ConnectorExpandMask }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceGetRequest>): ConnectorServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceGetRequest): ConnectorServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                case /* c1.api.app.v1.ConnectorExpandMask expand_mask */ 3:
                    message.expandMask = ConnectorExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        /* c1.api.app.v1.ConnectorExpandMask expand_mask = 3; */
        if (message.expandMask)
            ConnectorExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceGetRequest
 */
export const ConnectorServiceGetRequest = new ConnectorServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceDeleteRequest$Type extends MessageType<ConnectorServiceDeleteRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceDeleteRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceDeleteRequest>): ConnectorServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceDeleteRequest): ConnectorServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceDeleteRequest
 */
export const ConnectorServiceDeleteRequest = new ConnectorServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceDeleteResponse$Type extends MessageType<ConnectorServiceDeleteResponse> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceDeleteResponse", []);
    }
    create(value?: PartialMessage<ConnectorServiceDeleteResponse>): ConnectorServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceDeleteResponse): ConnectorServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceDeleteResponse
 */
export const ConnectorServiceDeleteResponse = new ConnectorServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceListRequest$Type extends MessageType<ConnectorServiceListRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceListRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => ConnectorExpandMask }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceListRequest>): ConnectorServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceListRequest): ConnectorServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.ConnectorExpandMask expand_mask */ 4:
                    message.expandMask = ConnectorExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.ConnectorExpandMask expand_mask = 4; */
        if (message.expandMask)
            ConnectorExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceListRequest
 */
export const ConnectorServiceListRequest = new ConnectorServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceListResponse$Type extends MessageType<ConnectorServiceListResponse> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceListResponse>): ConnectorServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceListResponse): ConnectorServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.ConnectorView list */ 1:
                    message.list.push(ConnectorView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.ConnectorView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ConnectorView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceListResponse
 */
export const ConnectorServiceListResponse = new ConnectorServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceLogsRequest$Type extends MessageType<ConnectorServiceLogsRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceLogsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceLogsRequest>): ConnectorServiceLogsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.id = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceLogsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceLogsRequest): ConnectorServiceLogsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceLogsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceLogsRequest
 */
export const ConnectorServiceLogsRequest = new ConnectorServiceLogsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorLog$Type extends MessageType<ConnectorLog> {
    constructor() {
        super("c1.api.app.v1.ConnectorLog", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "msg", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "fields", kind: "message", T: () => Struct }
        ]);
    }
    create(value?: PartialMessage<ConnectorLog>): ConnectorLog {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.msg = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorLog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorLog): ConnectorLog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* string msg */ 3:
                    message.msg = reader.string();
                    break;
                case /* google.protobuf.Struct fields */ 4:
                    message.fields = Struct.internalBinaryRead(reader, reader.uint32(), options, message.fields);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorLog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string msg = 3; */
        if (message.msg !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.msg);
        /* google.protobuf.Struct fields = 4; */
        if (message.fields)
            Struct.internalBinaryWrite(message.fields, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorLog
 */
export const ConnectorLog = new ConnectorLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceLogsResponse$Type extends MessageType<ConnectorServiceLogsResponse> {
    constructor() {
        super("c1.api.app.v1.ConnectorServiceLogsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorLog },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceLogsResponse>): ConnectorServiceLogsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceLogsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceLogsResponse): ConnectorServiceLogsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.ConnectorLog list */ 1:
                    message.list.push(ConnectorLog.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceLogsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.ConnectorLog list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ConnectorLog.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorServiceLogsResponse
 */
export const ConnectorServiceLogsResponse = new ConnectorServiceLogsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorConfigFieldActivity$Type extends MessageType<ConnectorConfigFieldActivity> {
    constructor() {
        super("c1.api.app.v1.ConnectorConfigFieldActivity", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "field_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "1024" } } } },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "expires_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "options", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Option },
            { no: 10, name: "state", kind: "enum", T: () => ["c1.api.app.v1.FieldActivityState", FieldActivityState, "FIELD_ACTIVITY_STATE_"] }
        ]);
    }
    create(value?: PartialMessage<ConnectorConfigFieldActivity>): ConnectorConfigFieldActivity {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.fieldName = "";
        message.error = "";
        message.options = [];
        message.state = 0;
        if (value !== undefined)
            reflectionMergePartial<ConnectorConfigFieldActivity>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorConfigFieldActivity): ConnectorConfigFieldActivity {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string field_name */ 3:
                    message.fieldName = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 6:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* google.protobuf.Timestamp expires_at */ 7:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                case /* string error */ 8:
                    message.error = reader.string();
                    break;
                case /* repeated c1.api.app.v1.Option options */ 9:
                    message.options.push(Option.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.app.v1.FieldActivityState state */ 10:
                    message.state = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorConfigFieldActivity, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string field_name = 3; */
        if (message.fieldName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.fieldName);
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 6; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp expires_at = 7; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string error = 8; */
        if (message.error !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.error);
        /* repeated c1.api.app.v1.Option options = 9; */
        for (let i = 0; i < message.options.length; i++)
            Option.internalBinaryWrite(message.options[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.FieldActivityState state = 10; */
        if (message.state !== 0)
            writer.tag(10, WireType.Varint).int32(message.state);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorConfigFieldActivity
 */
export const ConnectorConfigFieldActivity = new ConnectorConfigFieldActivity$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorConfigFieldActivityRequest$Type extends MessageType<GetConnectorConfigFieldActivityRequest> {
    constructor() {
        super("c1.api.app.v1.GetConnectorConfigFieldActivityRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "field_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<GetConnectorConfigFieldActivityRequest>): GetConnectorConfigFieldActivityRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.fieldName = "";
        if (value !== undefined)
            reflectionMergePartial<GetConnectorConfigFieldActivityRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetConnectorConfigFieldActivityRequest): GetConnectorConfigFieldActivityRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string field_name */ 3:
                    message.fieldName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetConnectorConfigFieldActivityRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string field_name = 3; */
        if (message.fieldName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.fieldName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetConnectorConfigFieldActivityRequest
 */
export const GetConnectorConfigFieldActivityRequest = new GetConnectorConfigFieldActivityRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorConfigFieldActivityResponse$Type extends MessageType<GetConnectorConfigFieldActivityResponse> {
    constructor() {
        super("c1.api.app.v1.GetConnectorConfigFieldActivityResponse", [
            { no: 1, name: "item", kind: "message", T: () => ConnectorConfigFieldActivity }
        ]);
    }
    create(value?: PartialMessage<GetConnectorConfigFieldActivityResponse>): GetConnectorConfigFieldActivityResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetConnectorConfigFieldActivityResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetConnectorConfigFieldActivityResponse): GetConnectorConfigFieldActivityResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.ConnectorConfigFieldActivity item */ 1:
                    message.item = ConnectorConfigFieldActivity.internalBinaryRead(reader, reader.uint32(), options, message.item);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetConnectorConfigFieldActivityResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.ConnectorConfigFieldActivity item = 1; */
        if (message.item)
            ConnectorConfigFieldActivity.internalBinaryWrite(message.item, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetConnectorConfigFieldActivityResponse
 */
export const GetConnectorConfigFieldActivityResponse = new GetConnectorConfigFieldActivityResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorSyncLifecycle$Type extends MessageType<ConnectorSyncLifecycle> {
    constructor() {
        super("c1.api.app.v1.ConnectorSyncLifecycle", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "status", kind: "enum", T: () => ["c1.api.app.v1.ConnectorSyncLifecycleStatus", ConnectorSyncLifecycleStatus] },
            { no: 7, name: "sync_started_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "sync_completed_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 9, name: "stats", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 10, name: "c1z_sync_id", kind: "scalar", jsonName: "c1zSyncId", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 11, name: "sync_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 12, name: "processing_started_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 13, name: "processing_completed_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<ConnectorSyncLifecycle>): ConnectorSyncLifecycle {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.id = "";
        message.status = 0;
        message.stats = {};
        message.c1ZSyncId = "";
        message.syncType = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorSyncLifecycle>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorSyncLifecycle): ConnectorSyncLifecycle {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string id */ 3:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* c1.api.app.v1.ConnectorSyncLifecycleStatus status */ 6:
                    message.status = reader.int32();
                    break;
                case /* google.protobuf.Timestamp sync_started_at */ 7:
                    message.syncStartedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.syncStartedAt);
                    break;
                case /* google.protobuf.Timestamp sync_completed_at */ 8:
                    message.syncCompletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.syncCompletedAt);
                    break;
                case /* map<string, int64> stats */ 9:
                    this.binaryReadMap9(message.stats, reader, options);
                    break;
                case /* string c1z_sync_id */ 10:
                    message.c1ZSyncId = reader.string();
                    break;
                case /* string sync_type */ 11:
                    message.syncType = reader.string();
                    break;
                case /* google.protobuf.Timestamp processing_started_at */ 12:
                    message.processingStartedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.processingStartedAt);
                    break;
                case /* google.protobuf.Timestamp processing_completed_at */ 13:
                    message.processingCompletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.processingCompletedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap9(map: ConnectorSyncLifecycle["stats"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ConnectorSyncLifecycle["stats"] | undefined, val: ConnectorSyncLifecycle["stats"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.int64().toNumber();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.app.v1.ConnectorSyncLifecycle.stats");
            }
        }
        map[key ?? ""] = val ?? 0;
    }
    internalBinaryWrite(message: ConnectorSyncLifecycle, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string id = 3; */
        if (message.id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.ConnectorSyncLifecycleStatus status = 6; */
        if (message.status !== 0)
            writer.tag(6, WireType.Varint).int32(message.status);
        /* google.protobuf.Timestamp sync_started_at = 7; */
        if (message.syncStartedAt)
            Timestamp.internalBinaryWrite(message.syncStartedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp sync_completed_at = 8; */
        if (message.syncCompletedAt)
            Timestamp.internalBinaryWrite(message.syncCompletedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* map<string, int64> stats = 9; */
        for (let k of globalThis.Object.keys(message.stats))
            writer.tag(9, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.Varint).int64(message.stats[k]).join();
        /* string c1z_sync_id = 10; */
        if (message.c1ZSyncId !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.c1ZSyncId);
        /* string sync_type = 11; */
        if (message.syncType !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.syncType);
        /* google.protobuf.Timestamp processing_started_at = 12; */
        if (message.processingStartedAt)
            Timestamp.internalBinaryWrite(message.processingStartedAt, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp processing_completed_at = 13; */
        if (message.processingCompletedAt)
            Timestamp.internalBinaryWrite(message.processingCompletedAt, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorSyncLifecycle
 */
export const ConnectorSyncLifecycle = new ConnectorSyncLifecycle$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorSyncLifecycleRef$Type extends MessageType<ConnectorSyncLifecycleRef> {
    constructor() {
        super("c1.api.app.v1.ConnectorSyncLifecycleRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ConnectorSyncLifecycleRef>): ConnectorSyncLifecycleRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorSyncLifecycleRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorSyncLifecycleRef): ConnectorSyncLifecycleRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorSyncLifecycleRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorSyncLifecycleRef
 */
export const ConnectorSyncLifecycleRef = new ConnectorSyncLifecycleRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorAccountCreationSchemaRequest$Type extends MessageType<GetConnectorAccountCreationSchemaRequest> {
    constructor() {
        super("c1.api.app.v1.GetConnectorAccountCreationSchemaRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetConnectorAccountCreationSchemaRequest>): GetConnectorAccountCreationSchemaRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        if (value !== undefined)
            reflectionMergePartial<GetConnectorAccountCreationSchemaRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetConnectorAccountCreationSchemaRequest): GetConnectorAccountCreationSchemaRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetConnectorAccountCreationSchemaRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetConnectorAccountCreationSchemaRequest
 */
export const GetConnectorAccountCreationSchemaRequest = new GetConnectorAccountCreationSchemaRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorAccountCreationSchemaResponse$Type extends MessageType<GetConnectorAccountCreationSchemaResponse> {
    constructor() {
        super("c1.api.app.v1.GetConnectorAccountCreationSchemaResponse", [
            { no: 1, name: "account_creation_schema", kind: "message", T: () => ConnectorAccountCreationSchema }
        ]);
    }
    create(value?: PartialMessage<GetConnectorAccountCreationSchemaResponse>): GetConnectorAccountCreationSchemaResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetConnectorAccountCreationSchemaResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetConnectorAccountCreationSchemaResponse): GetConnectorAccountCreationSchemaResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.ConnectorAccountCreationSchema account_creation_schema */ 1:
                    message.accountCreationSchema = ConnectorAccountCreationSchema.internalBinaryRead(reader, reader.uint32(), options, message.accountCreationSchema);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetConnectorAccountCreationSchemaResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.ConnectorAccountCreationSchema account_creation_schema = 1; */
        if (message.accountCreationSchema)
            ConnectorAccountCreationSchema.internalBinaryWrite(message.accountCreationSchema, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetConnectorAccountCreationSchemaResponse
 */
export const GetConnectorAccountCreationSchemaResponse = new GetConnectorAccountCreationSchemaResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema$Type extends MessageType<ConnectorAccountCreationSchema> {
    constructor() {
        super("c1.api.app.v1.ConnectorAccountCreationSchema", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "field_map", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => ConnectorAccountCreationSchema_Field } },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<ConnectorAccountCreationSchema>): ConnectorAccountCreationSchema {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenantId = "";
        message.appId = "";
        message.connectorId = "";
        message.id = "";
        message.fieldMap = {};
        if (value !== undefined)
            reflectionMergePartial<ConnectorAccountCreationSchema>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorAccountCreationSchema): ConnectorAccountCreationSchema {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant_id */ 1:
                    message.tenantId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 3:
                    message.connectorId = reader.string();
                    break;
                case /* string id */ 4:
                    message.id = reader.string();
                    break;
                case /* map<string, c1.api.app.v1.ConnectorAccountCreationSchema.Field> field_map */ 5:
                    this.binaryReadMap5(message.fieldMap, reader, options);
                    break;
                case /* google.protobuf.Timestamp created_at */ 6:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 7:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 8:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap5(map: ConnectorAccountCreationSchema["fieldMap"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ConnectorAccountCreationSchema["fieldMap"] | undefined, val: ConnectorAccountCreationSchema["fieldMap"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = ConnectorAccountCreationSchema_Field.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.app.v1.ConnectorAccountCreationSchema.field_map");
            }
        }
        map[key ?? ""] = val ?? ConnectorAccountCreationSchema_Field.create();
    }
    internalBinaryWrite(message: ConnectorAccountCreationSchema, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant_id = 1; */
        if (message.tenantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenantId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 3; */
        if (message.connectorId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.connectorId);
        /* string id = 4; */
        if (message.id !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.id);
        /* map<string, c1.api.app.v1.ConnectorAccountCreationSchema.Field> field_map = 5; */
        for (let k of globalThis.Object.keys(message.fieldMap)) {
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            ConnectorAccountCreationSchema_Field.internalBinaryWrite(message.fieldMap[k], writer, options);
            writer.join().join();
        }
        /* google.protobuf.Timestamp created_at = 6; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 7; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 8; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorAccountCreationSchema
 */
export const ConnectorAccountCreationSchema = new ConnectorAccountCreationSchema$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_Field$Type extends MessageType<ConnectorAccountCreationSchema_Field> {
    constructor() {
        super("c1.api.app.v1.ConnectorAccountCreationSchema.Field", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "required", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "placeholder", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "deprecated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 100, name: "str", kind: "message", oneof: "field", T: () => ConnectorAccountCreationSchema_StringField },
            { no: 101, name: "bool", kind: "message", oneof: "field", T: () => ConnectorAccountCreationSchema_BoolField },
            { no: 102, name: "str_list", kind: "message", oneof: "field", T: () => ConnectorAccountCreationSchema_StringListField },
            { no: 103, name: "i", kind: "message", oneof: "field", T: () => ConnectorAccountCreationSchema_IntField },
            { no: 104, name: "m", kind: "message", oneof: "field", T: () => ConnectorAccountCreationSchema_MapField }
        ]);
    }
    create(value?: PartialMessage<ConnectorAccountCreationSchema_Field>): ConnectorAccountCreationSchema_Field {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.required = false;
        message.description = "";
        message.placeholder = "";
        message.order = 0;
        message.deprecated = false;
        message.field = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<ConnectorAccountCreationSchema_Field>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorAccountCreationSchema_Field): ConnectorAccountCreationSchema_Field {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* bool required */ 2:
                    message.required = reader.bool();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string placeholder */ 4:
                    message.placeholder = reader.string();
                    break;
                case /* int32 order */ 5:
                    message.order = reader.int32();
                    break;
                case /* bool deprecated */ 6:
                    message.deprecated = reader.bool();
                    break;
                case /* c1.api.app.v1.ConnectorAccountCreationSchema.StringField str */ 100:
                    message.field = {
                        oneofKind: "str",
                        str: ConnectorAccountCreationSchema_StringField.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).str)
                    };
                    break;
                case /* c1.api.app.v1.ConnectorAccountCreationSchema.BoolField bool */ 101:
                    message.field = {
                        oneofKind: "bool",
                        bool: ConnectorAccountCreationSchema_BoolField.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).bool)
                    };
                    break;
                case /* c1.api.app.v1.ConnectorAccountCreationSchema.StringListField str_list */ 102:
                    message.field = {
                        oneofKind: "strList",
                        strList: ConnectorAccountCreationSchema_StringListField.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).strList)
                    };
                    break;
                case /* c1.api.app.v1.ConnectorAccountCreationSchema.IntField i */ 103:
                    message.field = {
                        oneofKind: "i",
                        i: ConnectorAccountCreationSchema_IntField.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).i)
                    };
                    break;
                case /* c1.api.app.v1.ConnectorAccountCreationSchema.MapField m */ 104:
                    message.field = {
                        oneofKind: "m",
                        m: ConnectorAccountCreationSchema_MapField.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).m)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorAccountCreationSchema_Field, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* bool required = 2; */
        if (message.required !== false)
            writer.tag(2, WireType.Varint).bool(message.required);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string placeholder = 4; */
        if (message.placeholder !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.placeholder);
        /* int32 order = 5; */
        if (message.order !== 0)
            writer.tag(5, WireType.Varint).int32(message.order);
        /* bool deprecated = 6; */
        if (message.deprecated !== false)
            writer.tag(6, WireType.Varint).bool(message.deprecated);
        /* c1.api.app.v1.ConnectorAccountCreationSchema.StringField str = 100; */
        if (message.field.oneofKind === "str")
            ConnectorAccountCreationSchema_StringField.internalBinaryWrite(message.field.str, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.ConnectorAccountCreationSchema.BoolField bool = 101; */
        if (message.field.oneofKind === "bool")
            ConnectorAccountCreationSchema_BoolField.internalBinaryWrite(message.field.bool, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.ConnectorAccountCreationSchema.StringListField str_list = 102; */
        if (message.field.oneofKind === "strList")
            ConnectorAccountCreationSchema_StringListField.internalBinaryWrite(message.field.strList, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.ConnectorAccountCreationSchema.IntField i = 103; */
        if (message.field.oneofKind === "i")
            ConnectorAccountCreationSchema_IntField.internalBinaryWrite(message.field.i, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.ConnectorAccountCreationSchema.MapField m = 104; */
        if (message.field.oneofKind === "m")
            ConnectorAccountCreationSchema_MapField.internalBinaryWrite(message.field.m, writer.tag(104, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.Field
 */
export const ConnectorAccountCreationSchema_Field = new ConnectorAccountCreationSchema_Field$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_StringField$Type extends MessageType<ConnectorAccountCreationSchema_StringField> {
    constructor() {
        super("c1.api.app.v1.ConnectorAccountCreationSchema.StringField", [
            { no: 1, name: "default_value", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorAccountCreationSchema_StringField>): ConnectorAccountCreationSchema_StringField {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConnectorAccountCreationSchema_StringField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorAccountCreationSchema_StringField): ConnectorAccountCreationSchema_StringField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string default_value */ 1:
                    message.defaultValue = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorAccountCreationSchema_StringField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string default_value = 1; */
        if (message.defaultValue !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.defaultValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.StringField
 */
export const ConnectorAccountCreationSchema_StringField = new ConnectorAccountCreationSchema_StringField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_BoolField$Type extends MessageType<ConnectorAccountCreationSchema_BoolField> {
    constructor() {
        super("c1.api.app.v1.ConnectorAccountCreationSchema.BoolField", [
            { no: 1, name: "default_value", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorAccountCreationSchema_BoolField>): ConnectorAccountCreationSchema_BoolField {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConnectorAccountCreationSchema_BoolField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorAccountCreationSchema_BoolField): ConnectorAccountCreationSchema_BoolField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional bool default_value */ 1:
                    message.defaultValue = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorAccountCreationSchema_BoolField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional bool default_value = 1; */
        if (message.defaultValue !== undefined)
            writer.tag(1, WireType.Varint).bool(message.defaultValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.BoolField
 */
export const ConnectorAccountCreationSchema_BoolField = new ConnectorAccountCreationSchema_BoolField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_StringListField$Type extends MessageType<ConnectorAccountCreationSchema_StringListField> {
    constructor() {
        super("c1.api.app.v1.ConnectorAccountCreationSchema.StringListField", [
            { no: 1, name: "default_value", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorAccountCreationSchema_StringListField>): ConnectorAccountCreationSchema_StringListField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.defaultValue = [];
        if (value !== undefined)
            reflectionMergePartial<ConnectorAccountCreationSchema_StringListField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorAccountCreationSchema_StringListField): ConnectorAccountCreationSchema_StringListField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string default_value */ 1:
                    message.defaultValue.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorAccountCreationSchema_StringListField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string default_value = 1; */
        for (let i = 0; i < message.defaultValue.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.defaultValue[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.StringListField
 */
export const ConnectorAccountCreationSchema_StringListField = new ConnectorAccountCreationSchema_StringListField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_IntField$Type extends MessageType<ConnectorAccountCreationSchema_IntField> {
    constructor() {
        super("c1.api.app.v1.ConnectorAccountCreationSchema.IntField", [
            { no: 1, name: "default_value", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorAccountCreationSchema_IntField>): ConnectorAccountCreationSchema_IntField {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConnectorAccountCreationSchema_IntField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorAccountCreationSchema_IntField): ConnectorAccountCreationSchema_IntField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional int32 default_value */ 1:
                    message.defaultValue = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorAccountCreationSchema_IntField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional int32 default_value = 1; */
        if (message.defaultValue !== undefined)
            writer.tag(1, WireType.Varint).int32(message.defaultValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.IntField
 */
export const ConnectorAccountCreationSchema_IntField = new ConnectorAccountCreationSchema_IntField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_MapField$Type extends MessageType<ConnectorAccountCreationSchema_MapField> {
    constructor() {
        super("c1.api.app.v1.ConnectorAccountCreationSchema.MapField", [
            { no: 1, name: "default_value", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => ConnectorAccountCreationSchema_Field } }
        ]);
    }
    create(value?: PartialMessage<ConnectorAccountCreationSchema_MapField>): ConnectorAccountCreationSchema_MapField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.defaultValue = {};
        if (value !== undefined)
            reflectionMergePartial<ConnectorAccountCreationSchema_MapField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorAccountCreationSchema_MapField): ConnectorAccountCreationSchema_MapField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<string, c1.api.app.v1.ConnectorAccountCreationSchema.Field> default_value */ 1:
                    this.binaryReadMap1(message.defaultValue, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: ConnectorAccountCreationSchema_MapField["defaultValue"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ConnectorAccountCreationSchema_MapField["defaultValue"] | undefined, val: ConnectorAccountCreationSchema_MapField["defaultValue"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = ConnectorAccountCreationSchema_Field.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.app.v1.ConnectorAccountCreationSchema.MapField.default_value");
            }
        }
        map[key ?? ""] = val ?? ConnectorAccountCreationSchema_Field.create();
    }
    internalBinaryWrite(message: ConnectorAccountCreationSchema_MapField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<string, c1.api.app.v1.ConnectorAccountCreationSchema.Field> default_value = 1; */
        for (let k of globalThis.Object.keys(message.defaultValue)) {
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            ConnectorAccountCreationSchema_Field.internalBinaryWrite(message.defaultValue[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorAccountCreationSchema.MapField
 */
export const ConnectorAccountCreationSchema_MapField = new ConnectorAccountCreationSchema_MapField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorExternalSourceConfigSetRequest$Type extends MessageType<ConnectorExternalSourceConfigSetRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorExternalSourceConfigSetRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "external_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "external_connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "external_app_entitlement_filter_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ConnectorExternalSourceConfigSetRequest>): ConnectorExternalSourceConfigSetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.externalAppId = "";
        message.externalConnectorId = "";
        message.externalAppEntitlementFilterId = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorExternalSourceConfigSetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorExternalSourceConfigSetRequest): ConnectorExternalSourceConfigSetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string external_app_id */ 3:
                    message.externalAppId = reader.string();
                    break;
                case /* string external_connector_id */ 4:
                    message.externalConnectorId = reader.string();
                    break;
                case /* string external_app_entitlement_filter_id */ 5:
                    message.externalAppEntitlementFilterId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorExternalSourceConfigSetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string external_app_id = 3; */
        if (message.externalAppId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.externalAppId);
        /* string external_connector_id = 4; */
        if (message.externalConnectorId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.externalConnectorId);
        /* string external_app_entitlement_filter_id = 5; */
        if (message.externalAppEntitlementFilterId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.externalAppEntitlementFilterId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorExternalSourceConfigSetRequest
 */
export const ConnectorExternalSourceConfigSetRequest = new ConnectorExternalSourceConfigSetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorExternalSourceConfig$Type extends MessageType<ConnectorExternalSourceConfig> {
    constructor() {
        super("c1.api.app.v1.ConnectorExternalSourceConfig", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "external_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "external_connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "external_app_entitlement_filter_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "deleted_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<ConnectorExternalSourceConfig>): ConnectorExternalSourceConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.externalAppId = "";
        message.externalConnectorId = "";
        message.externalAppEntitlementFilterId = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorExternalSourceConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorExternalSourceConfig): ConnectorExternalSourceConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string external_app_id */ 3:
                    message.externalAppId = reader.string();
                    break;
                case /* string external_connector_id */ 4:
                    message.externalConnectorId = reader.string();
                    break;
                case /* string external_app_entitlement_filter_id */ 5:
                    message.externalAppEntitlementFilterId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 6:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 7:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 8:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorExternalSourceConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string external_app_id = 3; */
        if (message.externalAppId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.externalAppId);
        /* string external_connector_id = 4; */
        if (message.externalConnectorId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.externalConnectorId);
        /* string external_app_entitlement_filter_id = 5; */
        if (message.externalAppEntitlementFilterId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.externalAppEntitlementFilterId);
        /* google.protobuf.Timestamp created_at = 6; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 7; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 8; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorExternalSourceConfig
 */
export const ConnectorExternalSourceConfig = new ConnectorExternalSourceConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorExternalSourceConfigGetRequest$Type extends MessageType<ConnectorExternalSourceConfigGetRequest> {
    constructor() {
        super("c1.api.app.v1.ConnectorExternalSourceConfigGetRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ConnectorExternalSourceConfigGetRequest>): ConnectorExternalSourceConfigGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorExternalSourceConfigGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorExternalSourceConfigGetRequest): ConnectorExternalSourceConfigGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorExternalSourceConfigGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorExternalSourceConfigGetRequest
 */
export const ConnectorExternalSourceConfigGetRequest = new ConnectorExternalSourceConfigGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCompletedConnectorSyncLifecycleRequest$Type extends MessageType<ListCompletedConnectorSyncLifecycleRequest> {
    constructor() {
        super("c1.api.app.v1.ListCompletedConnectorSyncLifecycleRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ListCompletedConnectorSyncLifecycleRequest>): ListCompletedConnectorSyncLifecycleRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListCompletedConnectorSyncLifecycleRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListCompletedConnectorSyncLifecycleRequest): ListCompletedConnectorSyncLifecycleRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListCompletedConnectorSyncLifecycleRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListCompletedConnectorSyncLifecycleRequest
 */
export const ListCompletedConnectorSyncLifecycleRequest = new ListCompletedConnectorSyncLifecycleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCompletedConnectorSyncLifecycleResponse$Type extends MessageType<ListCompletedConnectorSyncLifecycleResponse> {
    constructor() {
        super("c1.api.app.v1.ListCompletedConnectorSyncLifecycleResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorSyncLifecycle },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListCompletedConnectorSyncLifecycleResponse>): ListCompletedConnectorSyncLifecycleResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListCompletedConnectorSyncLifecycleResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListCompletedConnectorSyncLifecycleResponse): ListCompletedConnectorSyncLifecycleResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.ConnectorSyncLifecycle list */ 1:
                    message.list.push(ConnectorSyncLifecycle.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListCompletedConnectorSyncLifecycleResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.ConnectorSyncLifecycle list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ConnectorSyncLifecycle.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListCompletedConnectorSyncLifecycleResponse
 */
export const ListCompletedConnectorSyncLifecycleResponse = new ListCompletedConnectorSyncLifecycleResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorSyncDownloadURLRequest$Type extends MessageType<GetConnectorSyncDownloadURLRequest> {
    constructor() {
        super("c1.api.app.v1.GetConnectorSyncDownloadURLRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "sync_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetConnectorSyncDownloadURLRequest>): GetConnectorSyncDownloadURLRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.syncId = "";
        if (value !== undefined)
            reflectionMergePartial<GetConnectorSyncDownloadURLRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetConnectorSyncDownloadURLRequest): GetConnectorSyncDownloadURLRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string sync_id */ 3:
                    message.syncId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetConnectorSyncDownloadURLRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string sync_id = 3; */
        if (message.syncId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.syncId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetConnectorSyncDownloadURLRequest
 */
export const GetConnectorSyncDownloadURLRequest = new GetConnectorSyncDownloadURLRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorSyncDownloadURLResponse$Type extends MessageType<GetConnectorSyncDownloadURLResponse> {
    constructor() {
        super("c1.api.app.v1.GetConnectorSyncDownloadURLResponse", [
            { no: 1, name: "download_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetConnectorSyncDownloadURLResponse>): GetConnectorSyncDownloadURLResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.downloadUrl = "";
        if (value !== undefined)
            reflectionMergePartial<GetConnectorSyncDownloadURLResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetConnectorSyncDownloadURLResponse): GetConnectorSyncDownloadURLResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string download_url */ 1:
                    message.downloadUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetConnectorSyncDownloadURLResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string download_url = 1; */
        if (message.downloadUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.downloadUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetConnectorSyncDownloadURLResponse
 */
export const GetConnectorSyncDownloadURLResponse = new GetConnectorSyncDownloadURLResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListConnectorSyncLifecycleRequest$Type extends MessageType<ListConnectorSyncLifecycleRequest> {
    constructor() {
        super("c1.api.app.v1.ListConnectorSyncLifecycleRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ListConnectorSyncLifecycleRequest>): ListConnectorSyncLifecycleRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListConnectorSyncLifecycleRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListConnectorSyncLifecycleRequest): ListConnectorSyncLifecycleRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListConnectorSyncLifecycleRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListConnectorSyncLifecycleRequest
 */
export const ListConnectorSyncLifecycleRequest = new ListConnectorSyncLifecycleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListConnectorSyncLifecycleResponse$Type extends MessageType<ListConnectorSyncLifecycleResponse> {
    constructor() {
        super("c1.api.app.v1.ListConnectorSyncLifecycleResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorSyncLifecycle },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListConnectorSyncLifecycleResponse>): ListConnectorSyncLifecycleResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListConnectorSyncLifecycleResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListConnectorSyncLifecycleResponse): ListConnectorSyncLifecycleResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.ConnectorSyncLifecycle list */ 1:
                    message.list.push(ConnectorSyncLifecycle.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListConnectorSyncLifecycleResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.ConnectorSyncLifecycle list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ConnectorSyncLifecycle.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListConnectorSyncLifecycleResponse
 */
export const ListConnectorSyncLifecycleResponse = new ListConnectorSyncLifecycleResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditorValidateRequest$Type extends MessageType<EditorValidateRequest> {
    constructor() {
        super("c1.api.app.v1.EditorValidateRequest", [
            { no: 1, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1048576" } } } }
        ]);
    }
    create(value?: PartialMessage<EditorValidateRequest>): EditorValidateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.text = "";
        if (value !== undefined)
            reflectionMergePartial<EditorValidateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EditorValidateRequest): EditorValidateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string text */ 1:
                    message.text = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EditorValidateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string text = 1; */
        if (message.text !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.text);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.EditorValidateRequest
 */
export const EditorValidateRequest = new EditorValidateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditorValidateResponse$Type extends MessageType<EditorValidateResponse> {
    constructor() {
        super("c1.api.app.v1.EditorValidateResponse", [
            { no: 1, name: "markers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EditorMarker, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<EditorValidateResponse>): EditorValidateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.markers = [];
        if (value !== undefined)
            reflectionMergePartial<EditorValidateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EditorValidateResponse): EditorValidateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.editor.v1.EditorMarker markers */ 1:
                    message.markers.push(EditorMarker.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EditorValidateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.editor.v1.EditorMarker markers = 1; */
        for (let i = 0; i < message.markers.length; i++)
            EditorMarker.internalBinaryWrite(message.markers[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.EditorValidateResponse
 */
export const EditorValidateResponse = new EditorValidateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorScheduleCron$Type extends MessageType<ConnectorScheduleCron> {
    constructor() {
        super("c1.api.app.v1.ConnectorScheduleCron", [
            { no: 1, name: "cron_spec", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorScheduleCron>): ConnectorScheduleCron {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cronSpec = "";
        message.timezone = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorScheduleCron>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorScheduleCron): ConnectorScheduleCron {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string cron_spec */ 1:
                    message.cronSpec = reader.string();
                    break;
                case /* string timezone */ 2:
                    message.timezone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorScheduleCron, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string cron_spec = 1; */
        if (message.cronSpec !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.cronSpec);
        /* string timezone = 2; */
        if (message.timezone !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.timezone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorScheduleCron
 */
export const ConnectorScheduleCron = new ConnectorScheduleCron$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateConnectorScheduleRequest$Type extends MessageType<UpdateConnectorScheduleRequest> {
    constructor() {
        super("c1.api.app.v1.UpdateConnectorScheduleRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 100, name: "cron", kind: "message", oneof: "schedule", T: () => ConnectorScheduleCron }
        ]);
    }
    create(value?: PartialMessage<UpdateConnectorScheduleRequest>): UpdateConnectorScheduleRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.schedule = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<UpdateConnectorScheduleRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateConnectorScheduleRequest): UpdateConnectorScheduleRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* c1.api.app.v1.ConnectorScheduleCron cron */ 100:
                    message.schedule = {
                        oneofKind: "cron",
                        cron: ConnectorScheduleCron.internalBinaryRead(reader, reader.uint32(), options, (message.schedule as any).cron)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateConnectorScheduleRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* c1.api.app.v1.ConnectorScheduleCron cron = 100; */
        if (message.schedule.oneofKind === "cron")
            ConnectorScheduleCron.internalBinaryWrite(message.schedule.cron, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateConnectorScheduleRequest
 */
export const UpdateConnectorScheduleRequest = new UpdateConnectorScheduleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateConnectorScheduleResponse$Type extends MessageType<UpdateConnectorScheduleResponse> {
    constructor() {
        super("c1.api.app.v1.UpdateConnectorScheduleResponse", []);
    }
    create(value?: PartialMessage<UpdateConnectorScheduleResponse>): UpdateConnectorScheduleResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateConnectorScheduleResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateConnectorScheduleResponse): UpdateConnectorScheduleResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateConnectorScheduleResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateConnectorScheduleResponse
 */
export const UpdateConnectorScheduleResponse = new UpdateConnectorScheduleResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorSyncCronSchedule$Type extends MessageType<ConnectorSyncCronSchedule> {
    constructor() {
        super("c1.api.app.v1.ConnectorSyncCronSchedule", [
            { no: 1, name: "start", kind: "message", T: () => Timestamp },
            { no: 2, name: "cron_spec", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorSyncCronSchedule>): ConnectorSyncCronSchedule {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cronSpec = "";
        message.timezone = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorSyncCronSchedule>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorSyncCronSchedule): ConnectorSyncCronSchedule {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp start */ 1:
                    message.start = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.start);
                    break;
                case /* string cron_spec */ 2:
                    message.cronSpec = reader.string();
                    break;
                case /* string timezone */ 3:
                    message.timezone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorSyncCronSchedule, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp start = 1; */
        if (message.start)
            Timestamp.internalBinaryWrite(message.start, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cron_spec = 2; */
        if (message.cronSpec !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cronSpec);
        /* string timezone = 3; */
        if (message.timezone !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.timezone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ConnectorSyncCronSchedule
 */
export const ConnectorSyncCronSchedule = new ConnectorSyncCronSchedule$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.ConnectorService
 */
export const ConnectorService = new ServiceType("c1.api.app.v1.ConnectorService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/connectors/{id}", group: "Connector" }] } }, I: ConnectorServiceGetRequest, O: ConnectorServiceGetResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/connectors", query: { page_size: "page_size", page_token: "page_token" }, group: "Connector" }] } }, I: ConnectorServiceListRequest, O: ConnectorServiceListResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/connectors/create", group: "Connector" }] } }, I: ConnectorServiceCreateRequest, O: ConnectorServiceCreateResponse },
    { name: "CreateDelegated", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/connectors", group: "Connector" }] } }, I: ConnectorServiceCreateDelegatedRequest, O: ConnectorServiceCreateResponse },
    { name: "Upload", options: { "authz.method": { role: "EDITOR" } }, I: ConnectorServiceUploadRequest, O: ConnectorServiceUploadResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{connector.app_id}/connectors/{connector.id}", group: "Connector" }] } }, I: ConnectorServiceUpdateRequest, O: ConnectorServiceUpdateResponse },
    { name: "UpdateAllowIgnoreList", options: { "authz.method": { role: "EDITOR" } }, I: ConnectorServiceUpdateAllowIgnoreListRequest, O: ConnectorServiceUpdateResponse },
    { name: "UpdateConnectorSyncResourceTypesConfig", options: { "authz.method": { role: "EDITOR" } }, I: ConnectorServiceUpdateSyncResourceTypesConfigRequest, O: ConnectorServiceUpdateResponse },
    { name: "UpdateAdvancedConfig", options: { "authz.method": { role: "EDITOR" } }, I: ConnectorServiceUpdateAdvancedConfigRequest, O: ConnectorServiceUpdateResponse },
    { name: "UpdateDelegated", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{connector.app_id}/connectors/{connector.id}/delegated", group: "Connector" }] } }, I: ConnectorServiceUpdateDelegatedRequest, O: ConnectorServiceUpdateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/connectors/{id}", group: "Connector" }] } }, I: ConnectorServiceDeleteRequest, O: ConnectorServiceDeleteResponse },
    { name: "Logs", options: { "authz.method": { role: "VIEWER" } }, I: ConnectorServiceLogsRequest, O: ConnectorServiceLogsResponse },
    { name: "CreateAuthorizeURL", options: { "authz.method": { role: "EDITOR" } }, I: CreateAuthorizeURLRequest, O: CreateAuthorizeURLResponse },
    { name: "GetConnectorConfigFieldActivity", options: { "authz.method": { role: "EDITOR" } }, I: GetConnectorConfigFieldActivityRequest, O: GetConnectorConfigFieldActivityResponse },
    { name: "ForceSync", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/connectors/{connector_id}/force_sync", group: "Connector" }] } }, I: ForceSyncRequest, O: ForceSyncResponse },
    { name: "ResumeSync", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/connectors/{connector_id}/resume", group: "Connector" }] } }, I: ResumeSyncRequest, O: ResumeSyncResponse },
    { name: "ConfirmSyncValid", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/connectors/{connector_id}/confirm_sync_valid/{sync_lifecycle_id}", group: "Connector" }] } }, I: ConfirmSyncValidRequest, O: ConfirmSyncValidResponse },
    { name: "PauseSync", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/connectors/{connector_id}/pause", group: "Connector" }] } }, I: PauseSyncRequest, O: PauseSyncResponse },
    { name: "GetCredentials", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/connectors/{connector_id}/credentials/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "ConnectorCredential" }], group: "Connector" }] } }, I: ConnectorServiceGetCredentialsRequest, O: ConnectorServiceGetCredentialsResponse },
    { name: "ListCredentials", options: { "authz.method": { role: "OWNER" } }, I: ConnectorServiceListCredentialsRequest, O: ConnectorServiceListCredentialsResponse },
    { name: "RotateCredential", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/connectors/credentials", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "ConnectorCredential" }], group: "Connector" }] } }, I: ConnectorServiceRotateCredentialRequest, O: ConnectorServiceRotateCredentialResponse },
    { name: "RevokeCredential", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/connectors/{connector_id}/credentials/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "ConnectorCredential" }], group: "Connector" }] } }, I: ConnectorServiceRevokeCredentialRequest, O: ConnectorServiceRevokeCredentialResponse },
    { name: "GetConnectorSyncLifecycle", options: { "authz.method": { role: "VIEWER" } }, I: GetConnectorSyncLifecycleRequest, O: ConnectorSyncLifecycle },
    { name: "ListCompletedConnectorSyncLifecycle", options: { "authz.method": { role: "VIEWER" } }, I: ListCompletedConnectorSyncLifecycleRequest, O: ListCompletedConnectorSyncLifecycleResponse },
    { name: "GetConnectorExternalSourceConfig", options: { "authz.method": { role: "EDITOR" } }, I: ConnectorExternalSourceConfigGetRequest, O: ConnectorExternalSourceConfig },
    { name: "SetConnectorExternalSourceConfig", options: { "authz.method": { role: "EDITOR" } }, I: ConnectorExternalSourceConfigSetRequest, O: ConnectorExternalSourceConfig },
    { name: "ListConnectorSyncLifecycle", options: { "authz.method": { role: "VIEWER" } }, I: ListConnectorSyncLifecycleRequest, O: ListConnectorSyncLifecycleResponse },
    { name: "GetConnectorSyncDownloadURL", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/connectors/{connector_id}/syncs/{sync_id}/download_url", group: "Connector" }] } }, I: GetConnectorSyncDownloadURLRequest, O: GetConnectorSyncDownloadURLResponse },
    { name: "ValidateHTTPConnectorConfig", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/connectors/validate_config/http", group: "Connector" }] } }, I: EditorValidateRequest, O: EditorValidateResponse },
    { name: "UpdateConnectorSchedule", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/connectors/{connector_id}/schedule", stability: "STABILITY_ALPHA", group: "Connector" }] } }, I: UpdateConnectorScheduleRequest, O: UpdateConnectorScheduleResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppConnectorAccountCreationSchemaService
 */
export const AppConnectorAccountCreationSchemaService = new ServiceType("c1.api.app.v1.AppConnectorAccountCreationSchemaService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: GetConnectorAccountCreationSchemaRequest, O: GetConnectorAccountCreationSchemaResponse }
]);
